// @ts-nocheck
import { assetsInitialApi as api } from './initialApi';
export const addTagTypes = [
  'asset-controller',
  'Partner Vehicles',
  'legacy-update-date-migration-controller',
  'fleet-telemetry-migration-controller',
  'batch-boarding-vehicle-summary-migration-controller',
  'vehicle-boarding-workflow-session-migration-controller',
  'gm-vehicle-migration-controller',
  'connectivity-provider-migration-controller',
  'claimed-onstar-migration-controller',
  'onstar-support-status-migration-controller',
  'remote-command-controller',
  'ovi-vehicle-migration-controller',
  'batch-boarding-vehicles-controller',
  'ovi-vehicle-migration-test-data-controller',
  'verified-vehicle-controller',
  'vehicle-list-overview-controller',
  'asset-view-controller',
  'vehicle-diagnostics-list-controller',
  'battery-readiness-report-view-controller',
  'admin-controller',
  'dashboard-view-controller',
  'vehicle-boarding-workflow-session-controller',
  'asset-readiness-report-view-controller',
  'restart-connectivity-controller',
  'vehicles-ownership-controller',
  'connectivity-controller',
  'vehicle-field-action-view-controller',
  'event-subscriptions-controller',
  'tire-readiness-report-view-controller',
  'patch-asset-controller',
  'image-controller',
  'azure-ai-search-controller',
  'Vehicles',
  'Asset',
  'vehicle-boarding-profile-controller',
  'compliance-report-view-controller',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      updateAsset: build.mutation<UpdateAssetApiResponse, UpdateAssetApiArg>({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.body,
        }),
        invalidatesTags: ['asset-controller'],
      }),
      deleteAsset: build.mutation<DeleteAssetApiResponse, DeleteAssetApiArg>({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['asset-controller'],
      }),
      listPartnerVehicles: build.mutation<
        ListPartnerVehiclesApiResponse,
        ListPartnerVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/partner/2026-09-22/vehicles/list`,
          method: 'POST',
          body: queryArg.partnerVehicleListRequest,
        }),
        invalidatesTags: ['Partner Vehicles'],
      }),
      repairUpdateDates: build.mutation<
        RepairUpdateDatesApiResponse,
        RepairUpdateDatesApiArg
      >({
        query: (queryArg) => ({
          url: `/migration/2026-10-06/legacyUpdateDate/batch`,
          method: 'POST',
          body: queryArg.repairUpdateDateRequest,
        }),
        invalidatesTags: ['legacy-update-date-migration-controller'],
      }),
      resetFleetTelemetry: build.mutation<
        ResetFleetTelemetryApiResponse,
        ResetFleetTelemetryApiArg
      >({
        query: (queryArg) => ({
          url: `/migration/2026-06-30/fleetTelemetry/reset`,
          method: 'POST',
          body: queryArg.resetFleetTelemetryRequest,
        }),
        invalidatesTags: ['fleet-telemetry-migration-controller'],
      }),
      updateSummary: build.mutation<
        UpdateSummaryApiResponse,
        UpdateSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/migration/2026-03-24/batchBoardingVehicleSummary/summaries/${queryArg.summaryId}`,
          method: 'POST',
        }),
        invalidatesTags: [
          'batch-boarding-vehicle-summary-migration-controller',
        ],
      }),
      updateSession: build.mutation<
        UpdateSessionApiResponse,
        UpdateSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/migration/2026-02-24/vehicleBoardingSession/sessions/${queryArg.sessionId}`,
          method: 'POST',
        }),
        invalidatesTags: [
          'vehicle-boarding-workflow-session-migration-controller',
        ],
      }),
      updateVehicle: build.mutation<
        UpdateVehicleApiResponse,
        UpdateVehicleApiArg
      >({
        query: (queryArg) => ({
          url: `/migration/2026-02-24/gmVehicle/vehicles/${queryArg.vin}`,
          method: 'POST',
        }),
        invalidatesTags: ['gm-vehicle-migration-controller'],
      }),
      updateVehicle1: build.mutation<
        UpdateVehicle1ApiResponse,
        UpdateVehicle1ApiArg
      >({
        query: (queryArg) => ({
          url: `/migration/2026-02-24/connectivityProvider/vehicles/${queryArg.vin}`,
          method: 'POST',
        }),
        invalidatesTags: ['connectivity-provider-migration-controller'],
      }),
      updateVehicle2: build.mutation<
        UpdateVehicle2ApiResponse,
        UpdateVehicle2ApiArg
      >({
        query: (queryArg) => ({
          url: `/migration/2026-02-24/claimedOnstar/vehicles/${queryArg.vin}`,
          method: 'POST',
        }),
        invalidatesTags: ['claimed-onstar-migration-controller'],
      }),
      updateVehicleBatch: build.mutation<
        UpdateVehicleBatchApiResponse,
        UpdateVehicleBatchApiArg
      >({
        query: (queryArg) => ({
          url: `/migration/2026-02-24/claimedOnstar/vehicles/batch`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['claimed-onstar-migration-controller'],
      }),
      updateVehicle3: build.mutation<
        UpdateVehicle3ApiResponse,
        UpdateVehicle3ApiArg
      >({
        query: (queryArg) => ({
          url: `/migration/2025-09-23/onstarSupportStatus/vehicles/${queryArg.vin}`,
          method: 'POST',
        }),
        invalidatesTags: ['onstar-support-status-migration-controller'],
      }),
      executeRemoteCommandsMfa: build.mutation<
        ExecuteRemoteCommandsMfaApiResponse,
        ExecuteRemoteCommandsMfaApiArg
      >({
        query: (queryArg) => ({
          url: `/mfa/2025-05-20/remotecommands/${queryArg.commandType}/${queryArg.command}/${queryArg.vin}`,
          method: 'POST',
          body: queryArg.otpPayload,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'X-Device-Fingerprint': queryArg['X-Device-Fingerprint'],
            'User-Agent': queryArg['User-Agent'],
          },
        }),
        invalidatesTags: ['remote-command-controller'],
      }),
      resetVehicles: build.mutation<
        ResetVehiclesApiResponse,
        ResetVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/migration/ovi/vehicles/reset`,
          method: 'POST',
          body: queryArg.resetVehiclesOviMigrationRequest,
        }),
        invalidatesTags: ['ovi-vehicle-migration-controller'],
      }),
      cleanupFakeVins: build.mutation<
        CleanupFakeVinsApiResponse,
        CleanupFakeVinsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/migration/ovi/vehicles/fake/cleanup`,
          method: 'POST',
          body: queryArg.cleanupFakeVinsRequest,
        }),
        invalidatesTags: ['ovi-vehicle-migration-controller'],
      }),
      offboardAllOrganizationVehicles: build.mutation<
        OffboardAllOrganizationVehiclesApiResponse,
        OffboardAllOrganizationVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-08-11/boarding/organizations/${queryArg.organizationId}/offboardAll`,
          method: 'POST',
          headers: {
            'cs-idempotency-key': queryArg['cs-idempotency-key'],
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      bulkGetOviVehicles: build.mutation<
        BulkGetOviVehiclesApiResponse,
        BulkGetOviVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-07-14/migration/ovi/vehicles/basicInfo`,
          method: 'POST',
          body: queryArg.bulkGetOviVehiclesRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['ovi-vehicle-migration-controller'],
      }),
      validateVehicles: build.mutation<
        ValidateVehiclesApiResponse,
        ValidateVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-30/migration/ovi/vehicles/validate`,
          method: 'POST',
          body: queryArg.validateMigratedOviVehiclesRequest,
        }),
        invalidatesTags: ['ovi-vehicle-migration-controller'],
      }),
      seedVehicle: build.mutation<SeedVehicleApiResponse, SeedVehicleApiArg>({
        query: (queryArg) => ({
          url: `/2026-06-30/admin/ovi/vehicles/seed`,
          method: 'POST',
          body: queryArg.seedOviTestVehicleRequest,
        }),
        invalidatesTags: ['ovi-vehicle-migration-test-data-controller'],
      }),
      offboardVehicles: build.mutation<
        OffboardVehiclesApiResponse,
        OffboardVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/boarding/verifiedVehicles/offboard`,
          method: 'POST',
          body: queryArg.offboardVehiclesRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['verified-vehicle-controller'],
      }),
      listVerifiedVehicles: build.query<
        ListVerifiedVehiclesApiResponse,
        ListVerifiedVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/boarding/verifiedVehicles/list`,
          method: 'POST',
          body: queryArg.verifiedVehiclesListRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['verified-vehicle-controller'],
      }),
      listMigratedVehicles: build.query<
        ListMigratedVehiclesApiResponse,
        ListMigratedVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-19/migration/ovi/vehicles`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            oviAccountId: queryArg.oviAccountId,
            oviFleetId: queryArg.oviFleetId,
            oviVehicleId: queryArg.oviVehicleId,
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            assetId: queryArg.assetId,
            size: queryArg.size,
          },
        }),
        providesTags: ['ovi-vehicle-migration-controller'],
      }),
      syncVehicles: build.mutation<SyncVehiclesApiResponse, SyncVehiclesApiArg>(
        {
          query: (queryArg) => ({
            url: `/2026-05-19/migration/ovi/vehicles`,
            method: 'POST',
            body: queryArg.syncOviVehiclesRequest,
            headers: {
              'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
            },
          }),
          invalidatesTags: ['ovi-vehicle-migration-controller'],
        }
      ),
      subscriptionOnboardVehicles: build.mutation<
        SubscriptionOnboardVehiclesApiResponse,
        SubscriptionOnboardVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-05/boarding/subscriptions/onboard`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            subscriptionState: queryArg.subscriptionState,
            subscriptionOrgId: queryArg.subscriptionOrgId,
            planCode: queryArg.planCode,
            serviceCodes: queryArg.serviceCodes,
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      subscriptionOffboardVehicles: build.mutation<
        SubscriptionOffboardVehiclesApiResponse,
        SubscriptionOffboardVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-05-05/boarding/subscriptions/offboard`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      exportVehicleListOverviewCsvFromSearch: build.mutation<
        ExportVehicleListOverviewCsvFromSearchApiResponse,
        ExportVehicleListOverviewCsvFromSearchApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-03-10/views/vehicleOverviewList/export`,
          method: 'POST',
          body: queryArg.vehicleOverviewSearchRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timezone: queryArg.timezone,
          },
        }),
        invalidatesTags: ['vehicle-list-overview-controller'],
      }),
      bulkGetVehicleBasicInfo: build.mutation<
        BulkGetVehicleBasicInfoApiResponse,
        BulkGetVehicleBasicInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-02-10/vehicles/basicInfo`,
          method: 'POST',
          body: queryArg.bulkGetVehicleBasicInfoRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['asset-controller'],
      }),
      getVehicleOverviewList: build.query<
        GetVehicleOverviewListApiResponse,
        GetVehicleOverviewListApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-01-27/views/vehicleOverviewList`,
          method: 'POST',
          body: queryArg.vehicleOverviewSearchRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      exportVehicleDiagnosticsList: build.mutation<
        ExportVehicleDiagnosticsListApiResponse,
        ExportVehicleDiagnosticsListApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-01-13/views/vehicleDiagnosticsList/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timezone: queryArg.timezone,
            locale: queryArg.locale,
            timeZone: queryArg.timeZone,
            distanceUnit: queryArg.distanceUnit,
          },
        }),
        invalidatesTags: ['vehicle-diagnostics-list-controller'],
      }),
      getAssetBatteryReadinessV20260113: build.mutation<
        GetAssetBatteryReadinessV20260113ApiResponse,
        GetAssetBatteryReadinessV20260113ApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-01-13/views/batteryReadinessReport`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['battery-readiness-report-view-controller'],
      }),
      exportAssetBatteryReadinessCsvV20260113: build.mutation<
        ExportAssetBatteryReadinessCsvV20260113ApiResponse,
        ExportAssetBatteryReadinessCsvV20260113ApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-01-13/views/batteryReadinessReport/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            requestBody: queryArg.requestBody,
            locale: queryArg.locale,
            timeZone: queryArg.timeZone,
            distanceUnit: queryArg.distanceUnit,
          },
        }),
        invalidatesTags: ['battery-readiness-report-view-controller'],
      }),
      getVehiclesWithDriversAndPeripheralsUsingBdQuery: build.mutation<
        GetVehiclesWithDriversAndPeripheralsUsingBdQueryApiResponse,
        GetVehiclesWithDriversAndPeripheralsUsingBdQueryApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-12-30/views/vehicles-with-drivers-and-peripherals`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
        }),
        invalidatesTags: ['asset-view-controller'],
      }),
      probeVehicle: build.mutation<ProbeVehicleApiResponse, ProbeVehicleApiArg>(
        {
          query: (queryArg) => ({
            url: `/2025-12-30/admin/vehicles/${queryArg.vin}/probe`,
            method: 'POST',
          }),
          invalidatesTags: ['admin-controller'],
        }
      ),
      getVehiclesWithDriversAndPeripherals: build.mutation<
        GetVehiclesWithDriversAndPeripheralsApiResponse,
        GetVehiclesWithDriversAndPeripheralsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-12-16/views/vehicles-with-drivers-and-peripherals`,
          method: 'POST',
          body: queryArg.vehiclesWithDriversAndPeripheralsRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
          },
        }),
        invalidatesTags: ['asset-view-controller'],
      }),
      changeFleetForVehicles: build.mutation<
        ChangeFleetForVehiclesApiResponse,
        ChangeFleetForVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-12-16/bulkChangeFleet`,
          method: 'POST',
          body: queryArg.changeFleetRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['asset-controller'],
      }),
      cancelBatch: build.mutation<CancelBatchApiResponse, CancelBatchApiArg>({
        query: (queryArg) => ({
          url: `/2025-12-02/boarding/batches/${queryArg.batchId}/cancel`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      exportVehicleListOverviewCsv: build.mutation<
        ExportVehicleListOverviewCsvApiResponse,
        ExportVehicleListOverviewCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-11-18/views/vehicleOverviewList/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            timezone: queryArg.timezone,
            locale: queryArg.locale,
            timeZone: queryArg.timeZone,
            distanceUnit: queryArg.distanceUnit,
          },
        }),
        invalidatesTags: ['vehicle-list-overview-controller'],
      }),
      getVehicleOverviewList1: build.mutation<
        GetVehicleOverviewList1ApiResponse,
        GetVehicleOverviewList1ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-11-04/views/vehicleOverviewList`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['vehicle-list-overview-controller'],
      }),
      getVehicleDiagnosticsList: build.query<
        GetVehicleDiagnosticsListApiResponse,
        GetVehicleDiagnosticsListApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-11-04/views/vehicleDiagnosticsList`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['vehicle-diagnostics-list-controller'],
      }),
      exportPendingConnectionVehicles: build.mutation<
        ExportPendingConnectionVehiclesApiResponse,
        ExportPendingConnectionVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-10-07/views/pendingConnectionVehicles/export`,
          method: 'POST',
          body: queryArg.pendingVehicleExportRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            size: queryArg.size,
            vin: queryArg.vin,
            subscriberAccountNumber: queryArg.subscriberAccountNumber,
            accountOwnerEmailId: queryArg.accountOwnerEmailId,
            fan: queryArg.fan,
            stationId: queryArg.stationId,
            pendingConnectionStatuses: queryArg.pendingConnectionStatuses,
            connectivityIssueCategories: queryArg.connectivityIssueCategories,
            vehicleYear: queryArg.vehicleYear,
            vehicleMakes: queryArg.vehicleMakes,
            vehicleModel: queryArg.vehicleModel,
          },
        }),
        invalidatesTags: ['dashboard-view-controller'],
      }),
      exportPendingOnboardingVehicles: build.mutation<
        ExportPendingOnboardingVehiclesApiResponse,
        ExportPendingOnboardingVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-10-07/boarding/vehicles/pending/export`,
          method: 'POST',
          body: queryArg.pendingVehicleExportRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            size: queryArg.size,
            status: queryArg.status,
            reviewReasons: queryArg.reviewReasons,
            fan: queryArg.fan,
            subscriberAccountNumber: queryArg.subscriberAccountNumber,
            accountOwnerEmailId: queryArg.accountOwnerEmailId,
            stationId: queryArg.stationId,
            vehicleYear: queryArg.vehicleYear,
            vehicleMakes: queryArg.vehicleMakes,
            vehicleModel: queryArg.vehicleModel,
          },
        }),
        invalidatesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      refreshBatchSummary: build.mutation<
        RefreshBatchSummaryApiResponse,
        RefreshBatchSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-09-23/boarding/batches/${queryArg.batchId}/refresh`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      getAssetReadinessV20250909: build.mutation<
        GetAssetReadinessV20250909ApiResponse,
        GetAssetReadinessV20250909ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-09-09/views/readinessReport`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['asset-readiness-report-view-controller'],
      }),
      exportAssetReadinessCsvV20250909: build.mutation<
        ExportAssetReadinessCsvV20250909ApiResponse,
        ExportAssetReadinessCsvV20250909ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-09-09/views/readinessReport/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            requestBody: queryArg.requestBody,
            locale: queryArg.locale,
            timeZone: queryArg.timeZone,
            distanceUnit: queryArg.distanceUnit,
          },
        }),
        invalidatesTags: ['asset-readiness-report-view-controller'],
      }),
      exportAssetFluidReadinessCsvV20250909: build.mutation<
        ExportAssetFluidReadinessCsvV20250909ApiResponse,
        ExportAssetFluidReadinessCsvV20250909ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-09-09/views/fluidReadinessReport/export`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            requestBody: queryArg.requestBody,
            locale: queryArg.locale,
            timeZone: queryArg.timeZone,
            distanceUnit: queryArg.distanceUnit,
          },
        }),
        invalidatesTags: ['asset-readiness-report-view-controller'],
      }),
      migratePreviouslyConnectedVehicleToConnectivity: build.mutation<
        MigratePreviouslyConnectedVehicleToConnectivityApiResponse,
        MigratePreviouslyConnectedVehicleToConnectivityApiArg
      >({
        query: () => ({
          url: `/2025-08-26/connectivity/restart/migrate`,
          method: 'POST',
        }),
        invalidatesTags: ['restart-connectivity-controller'],
      }),
      getBatchIgnitionStatus: build.mutation<
        GetBatchIgnitionStatusApiResponse,
        GetBatchIgnitionStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-08-12/views/vehicleIgnitionStatuses`,
          method: 'POST',
          body: queryArg.vehicleIgnitionStatusBatchRequest,
        }),
        invalidatesTags: ['asset-view-controller'],
      }),
      archiveVehicleBoardingSession: build.mutation<
        ArchiveVehicleBoardingSessionApiResponse,
        ArchiveVehicleBoardingSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-08-12/boarding/vehicles/${queryArg.vin}/sessions/${queryArg.sessionId}/archive`,
          method: 'POST',
        }),
        invalidatesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      sendConnectivityRestartRequest: build.mutation<
        SendConnectivityRestartRequestApiResponse,
        SendConnectivityRestartRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-07-29/admin/connectivity/restart`,
          method: 'POST',
          body: queryArg.restartConnectivityRequest,
          params: {
            connectivityRestartRequest: queryArg.connectivityRestartRequest,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      retryOnboardingVehicles: build.mutation<
        RetryOnboardingVehiclesApiResponse,
        RetryOnboardingVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-07-15/onboarding/vehicles/ownership/retry`,
          method: 'POST',
          body: queryArg.retryOnboardingVehicleBatchRequest,
        }),
        invalidatesTags: ['vehicles-ownership-controller'],
      }),
      triggerSearchIndexRefresh: build.mutation<
        TriggerSearchIndexRefreshApiResponse,
        TriggerSearchIndexRefreshApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-07-15/admin/vehicles/searchIndexRefresh`,
          method: 'POST',
          body: queryArg.body,
          params: {
            assetIds: queryArg.assetIds,
            batchSize: queryArg.batchSize,
            typeToRefresh: queryArg.typeToRefresh,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      cancelSessions: build.mutation<
        CancelSessionsApiResponse,
        CancelSessionsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-06-17/connectivity/session/cancel`,
          method: 'POST',
          body: queryArg.cancelConnectivitySessionRequest,
        }),
        invalidatesTags: ['connectivity-controller'],
      }),
      getMapAssetDetails: build.query<
        GetMapAssetDetailsApiResponse,
        GetMapAssetDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-04-08/views/mapsVehicleList`,
          method: 'POST',
          body: queryArg.vehicleListMapsRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      getMapLocationSummary: build.query<
        GetMapLocationSummaryApiResponse,
        GetMapLocationSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-04-08/views/mapsLocationSummary`,
          method: 'POST',
          body: queryArg.vehicleLocationMapsRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      terminateVehicleBoardingSession: build.mutation<
        TerminateVehicleBoardingSessionApiResponse,
        TerminateVehicleBoardingSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-03-26/boarding/vehicles/${queryArg.vin}/sessions/${queryArg.sessionId}/terminate`,
          method: 'POST',
        }),
        invalidatesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      batchOffBoardVehicles: build.mutation<
        BatchOffBoardVehiclesApiResponse,
        BatchOffBoardVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-03-11/boarding/vehicles/offboard`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            remoteProvider: queryArg.remoteProvider,
            telemetryProvider: queryArg.telemetryProvider,
            uploadType: queryArg.uploadType,
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      refreshVehicleData: build.mutation<
        RefreshVehicleDataApiResponse,
        RefreshVehicleDataApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-02-25/admin/vehicles/refresh`,
          method: 'POST',
          body: queryArg.vehicleDataRefreshRequest,
          params: {
            dryRun: queryArg.dryRun,
            restartConsent: queryArg.restartConsent,
            restartEnrollment: queryArg.restartEnrollment,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      triggerAddCapabilitiesEvent: build.mutation<
        TriggerAddCapabilitiesEventApiResponse,
        TriggerAddCapabilitiesEventApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-02-25/admin/triggerAssetCapabilitiesEvent`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            organizationId: queryArg.organizationId,
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            assetIds: queryArg.assetIds,
            batchSize: queryArg.batchSize,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      batchOnboardVehiclesV2: build.mutation<
        BatchOnboardVehiclesV2ApiResponse,
        BatchOnboardVehiclesV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-01-14/boarding/vehicles/onboard`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'X-Boarding-Connection-Policy':
              queryArg['X-Boarding-Connection-Policy'],
          },
          params: {
            remoteProvider: queryArg.remoteProvider,
            telemetryProvider: queryArg.telemetryProvider,
            uploadType: queryArg.uploadType,
          },
        }),
        invalidatesTags: ['batch-boarding-vehicles-controller'],
      }),
      triggerEvent: build.mutation<TriggerEventApiResponse, TriggerEventApiArg>(
        {
          query: (queryArg) => ({
            url: `/2025-01-01/triggerAssetCreationEvent`,
            method: 'POST',
            body: queryArg.body,
            params: {
              assetIds: queryArg.assetIds,
            },
          }),
          invalidatesTags: ['asset-controller'],
        }
      ),
      getActiveFieldActionVehicleSummary: build.mutation<
        GetActiveFieldActionVehicleSummaryApiResponse,
        GetActiveFieldActionVehicleSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-12-04/fieldactions/vehicleSummary`,
          method: 'POST',
          body: queryArg.body,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            vehicleFieldActionSummaryRequest:
              queryArg.vehicleFieldActionSummaryRequest,
          },
        }),
        invalidatesTags: ['vehicle-field-action-view-controller'],
      }),
      getAssetReadinessV20241203: build.mutation<
        GetAssetReadinessV20241203ApiResponse,
        GetAssetReadinessV20241203ApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-12-03/views/readinessReport`,
          method: 'POST',
          body: queryArg.bdPageRequest,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
          },
        }),
        invalidatesTags: ['asset-readiness-report-view-controller'],
      }),
      rejectVehicleProofOfOwnership: build.mutation<
        RejectVehicleProofOfOwnershipApiResponse,
        RejectVehicleProofOfOwnershipApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-11-11/onboarding/vehicles/ownership/reject`,
          method: 'POST',
          body: queryArg.vehicleOwnershipOperationBatchRequest,
        }),
        invalidatesTags: ['vehicles-ownership-controller'],
      }),
      confirmVehicleProofOfOwnership: build.mutation<
        ConfirmVehicleProofOfOwnershipApiResponse,
        ConfirmVehicleProofOfOwnershipApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-11-11/onboarding/vehicles/ownership/confirm`,
          method: 'POST',
          body: queryArg.vehicleOwnershipOperationBatchRequest,
        }),
        invalidatesTags: ['vehicles-ownership-controller'],
      }),
      getFieldActionSummaryReport: build.mutation<
        GetFieldActionSummaryReportApiResponse,
        GetFieldActionSummaryReportApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-10-23/fieldactions/vehicleFieldActionReport`,
          method: 'POST',
          body: queryArg.vehicleFieldActionReportRequest,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-bd-fleet': queryArg['x-bd-fleet'],
          },
        }),
        invalidatesTags: ['vehicle-field-action-view-controller'],
      }),
      upsertAsset: build.mutation<UpsertAssetApiResponse, UpsertAssetApiArg>({
        query: (queryArg) => ({
          url: `/2024-07-31/upsert`,
          method: 'POST',
          body: queryArg.body,
          params: {
            isReEnrolling: queryArg.isReEnrolling,
          },
        }),
        invalidatesTags: ['asset-controller'],
      }),
      getAssetsByPage: build.mutation<
        GetAssetsByPageApiResponse,
        GetAssetsByPageApiArg
      >({
        query: (queryArg) => ({
          url: `/2023-03-14/views/enhancements`,
          method: 'POST',
          body: queryArg.bdPageRequest,
        }),
        invalidatesTags: ['asset-view-controller'],
      }),
      doSubscribeV2: build.mutation<
        DoSubscribeV2ApiResponse,
        DoSubscribeV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/2022-05-24/eventsubscriptions`,
          method: 'POST',
          body: queryArg.eventSubscriptionRequestV2,
        }),
        invalidatesTags: ['event-subscriptions-controller'],
      }),
      getAssetWithTireReadiness: build.mutation<
        GetAssetWithTireReadinessApiResponse,
        GetAssetWithTireReadinessApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/views/tireReadinessReport`,
          method: 'POST',
          body: queryArg.bdPageRequest,
        }),
        invalidatesTags: ['tire-readiness-report-view-controller'],
      }),
      searchAssets: build.mutation<SearchAssetsApiResponse, SearchAssetsApiArg>(
        {
          query: (queryArg) => ({
            url: `/2021-11-15/searches`,
            method: 'POST',
            body: queryArg.bdPageRequest,
          }),
          invalidatesTags: ['asset-controller'],
        }
      ),
      updateProtectedFieldsForAsset: build.mutation<
        UpdateProtectedFieldsForAssetApiResponse,
        UpdateProtectedFieldsForAssetApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/admin/${queryArg.pathAssetId}`,
          method: 'POST',
          body: queryArg.protectedFieldsUpdateRequest,
          headers: {
            assetId: queryArg.headerAssetId,
          },
          params: {
            request: queryArg.request,
          },
        }),
        invalidatesTags: ['admin-controller'],
      }),
      resetOwnership: build.mutation<
        ResetOwnershipApiResponse,
        ResetOwnershipApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-07-28/reset/ownership/${queryArg.id}`,
          method: 'PATCH',
        }),
        invalidatesTags: ['patch-asset-controller'],
      }),
      patchVehicleProbe: build.mutation<
        PatchVehicleProbeApiResponse,
        PatchVehicleProbeApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-12-02/vehicles/${queryArg.vin}/probe`,
          method: 'PATCH',
          body: queryArg.vehicleProbe,
        }),
        invalidatesTags: ['patch-asset-controller'],
      }),
      resetOwnership1: build.mutation<
        ResetOwnership1ApiResponse,
        ResetOwnership1ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-04-08/reset/ownership/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateVehicleJson,
        }),
        invalidatesTags: ['patch-asset-controller'],
      }),
      patchVehicleInfoFields: build.mutation<
        PatchVehicleInfoFieldsApiResponse,
        PatchVehicleInfoFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-02-25/vehicle/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.upsertVehicleJson,
        }),
        invalidatesTags: ['patch-asset-controller'],
      }),
      updateConfiguration: build.mutation<
        UpdateConfigurationApiResponse,
        UpdateConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15`,
          method: 'PATCH',
          body: queryArg.updateConfigurationJson,
          params: {
            filters: queryArg.filters,
          },
        }),
        invalidatesTags: ['asset-controller'],
      }),
      listAssetsWithArrayUpdateDate: build.query<
        ListAssetsWithArrayUpdateDateApiResponse,
        ListAssetsWithArrayUpdateDateApiArg
      >({
        query: (queryArg) => ({
          url: `/migration/2026-10-06/legacyUpdateDate`,
          params: {
            pageSize: queryArg.pageSize,
          },
        }),
        providesTags: ['legacy-update-date-migration-controller'],
      }),
      listSummaries: build.query<ListSummariesApiResponse, ListSummariesApiArg>(
        {
          query: (queryArg) => ({
            url: `/migration/2026-03-24/batchBoardingVehicleSummary/summaries`,
            headers: {
              'cs-continuation-token': queryArg['cs-continuation-token'],
            },
            params: {
              pageSize: queryArg.pageSize,
              organizationId: queryArg.organizationId,
            },
          }),
          providesTags: ['batch-boarding-vehicle-summary-migration-controller'],
        }
      ),
      listSessions: build.query<ListSessionsApiResponse, ListSessionsApiArg>({
        query: (queryArg) => ({
          url: `/migration/2026-02-24/vehicleBoardingSession/sessions`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            pageSize: queryArg.pageSize,
            organizationId: queryArg.organizationId,
          },
        }),
        providesTags: [
          'vehicle-boarding-workflow-session-migration-controller',
        ],
      }),
      listVehicles: build.query<ListVehiclesApiResponse, ListVehiclesApiArg>({
        query: (queryArg) => ({
          url: `/migration/2026-02-24/gmVehicle/vehicles`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            pageSize: queryArg.pageSize,
            organizationId: queryArg.organizationId,
          },
        }),
        providesTags: ['gm-vehicle-migration-controller'],
      }),
      listVehicles1: build.query<ListVehicles1ApiResponse, ListVehicles1ApiArg>(
        {
          query: (queryArg) => ({
            url: `/migration/2026-02-24/connectivityProvider/vehicles`,
            headers: {
              'cs-continuation-token': queryArg['cs-continuation-token'],
            },
            params: {
              pageSize: queryArg.pageSize,
              organizationId: queryArg.organizationId,
            },
          }),
          providesTags: ['connectivity-provider-migration-controller'],
        }
      ),
      listVehicles2: build.query<ListVehicles2ApiResponse, ListVehicles2ApiArg>(
        {
          query: (queryArg) => ({
            url: `/migration/2026-02-24/claimedOnstar/vehicles`,
            params: {
              pageSize: queryArg.pageSize,
            },
          }),
          providesTags: ['claimed-onstar-migration-controller'],
        }
      ),
      listVehicles3: build.query<ListVehicles3ApiResponse, ListVehicles3ApiArg>(
        {
          query: (queryArg) => ({
            url: `/migration/2025-09-23/onstarSupportStatus/vehicles`,
            headers: {
              'cs-continuation-token': queryArg['cs-continuation-token'],
            },
            params: {
              pageSize: queryArg.pageSize,
              onstarSupportStatus: queryArg.onstarSupportStatus,
              organizationId: queryArg.organizationId,
            },
          }),
          providesTags: ['onstar-support-status-migration-controller'],
        }
      ),
      getVehicleImageUrl: build.query<
        GetVehicleImageUrlApiResponse,
        GetVehicleImageUrlApiArg
      >({
        query: (queryArg) => ({ url: `/image/${queryArg.vin}/2025-07-30` }),
        providesTags: ['image-controller'],
      }),
      getVehicleStatusDashboardSummaryMetricsV20260602: build.query<
        GetVehicleStatusDashboardSummaryMetricsV20260602ApiResponse,
        GetVehicleStatusDashboardSummaryMetricsV20260602ApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/views/vehicleStatusDashboardSummary`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getVehicleImageUrlWithParams: build.query<
        GetVehicleImageUrlWithParamsApiResponse,
        GetVehicleImageUrlWithParamsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-12-16/${queryArg.vin}/image`,
          params: {
            size: queryArg.size,
            angle: queryArg.angle,
            isTransparentBackground: queryArg.isTransparentBackground,
          },
        }),
        providesTags: ['asset-controller'],
      }),
      getPropulsionSummary: build.query<
        GetPropulsionSummaryApiResponse,
        GetPropulsionSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-10-07/views/propulsionSummary`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      listBatchSummaries: build.query<
        ListBatchSummariesApiResponse,
        ListBatchSummariesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-09-23/boarding/batches`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            createdBy: queryArg.createdBy,
            status: queryArg.status,
            boardingType: queryArg.boardingType,
            sourceTypes: queryArg.sourceTypes,
            size: queryArg.size,
          },
        }),
        providesTags: ['batch-boarding-vehicles-controller'],
      }),
      getBatchSummaryById: build.query<
        GetBatchSummaryByIdApiResponse,
        GetBatchSummaryByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-09-23/boarding/batches/${queryArg.batchId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['batch-boarding-vehicles-controller'],
      }),
      getBatchSessionsById: build.query<
        GetBatchSessionsByIdApiResponse,
        GetBatchSessionsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-09-23/boarding/batches/${queryArg.batchId}/sessions`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            vin: queryArg.vin,
            status: queryArg.status,
            size: queryArg.size,
          },
        }),
        providesTags: ['batch-boarding-vehicles-controller'],
      }),
      get20250923BoardingBatchesByBatchIdExtended: build.query<
        Get20250923BoardingBatchesByBatchIdExtendedApiResponse,
        Get20250923BoardingBatchesByBatchIdExtendedApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-09-23/boarding/batches/${queryArg.batchId}/extended`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['batch-boarding-vehicles-controller'],
      }),
      exportBatchVehiclesToCsv: build.query<
        ExportBatchVehiclesToCsvApiResponse,
        ExportBatchVehiclesToCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-09-23/boarding/batches/${queryArg.batchId}/export`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            vin: queryArg.vin,
            status: queryArg.status,
            locale: queryArg.locale,
            timeZone: queryArg.timeZone,
            distanceUnit: queryArg.distanceUnit,
          },
        }),
        providesTags: ['batch-boarding-vehicles-controller'],
      }),
      listPendingConnectionVehicles: build.query<
        ListPendingConnectionVehiclesApiResponse,
        ListPendingConnectionVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-08-26/views/pendingConnectionVehicles`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            vin: queryArg.vin,
            subscriberAccountNumber: queryArg.subscriberAccountNumber,
            accountOwnerEmailId: queryArg.accountOwnerEmailId,
            fan: queryArg.fan,
            stationId: queryArg.stationId,
            pendingConnectionStatuses: queryArg.pendingConnectionStatuses,
            connectivityIssueCategories: queryArg.connectivityIssueCategories,
            vehicleYear: queryArg.vehicleYear,
            vehicleMakes: queryArg.vehicleMakes,
            vehicleModel: queryArg.vehicleModel,
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getOilLifeSummaryMetricsV20250826: build.query<
        GetOilLifeSummaryMetricsV20250826ApiResponse,
        GetOilLifeSummaryMetricsV20250826ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-08-26/views/oilLifeDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getDiagnosticsSummaryMetricsV20250826: build.query<
        GetDiagnosticsSummaryMetricsV20250826ApiResponse,
        GetDiagnosticsSummaryMetricsV20250826ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-08-26/views/diagnosticDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getConnectivityStatusDashboardSummaryMetricsV20250826: build.query<
        GetConnectivityStatusDashboardSummaryMetricsV20250826ApiResponse,
        GetConnectivityStatusDashboardSummaryMetricsV20250826ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-08-26/views/connectivityStatusDashboardSummary`,
          headers: {
            orgId: queryArg.orgId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getChargeSummaryMetricsV20250826: build.query<
        GetChargeSummaryMetricsV20250826ApiResponse,
        GetChargeSummaryMetricsV20250826ApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-08-26/views/chargeDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['dashboard-view-controller'],
      }),
      getSummaryOfBoardingSessions: build.query<
        GetSummaryOfBoardingSessionsApiResponse,
        GetSummaryOfBoardingSessionsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-08-12/boarding/batch/${queryArg.batchId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      searchAsset: build.query<SearchAssetApiResponse, SearchAssetApiArg>({
        query: (queryArg) => ({
          url: `/2025-07-29/asset-joint-index/search`,
          params: {
            searchText: queryArg.searchText,
            top: queryArg.top,
            skip: queryArg.skip,
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            filters: queryArg.filters,
            fieldsToSelect: queryArg.fieldsToSelect,
            queryType: queryArg.queryType,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      getVehiclesWithDrivers: build.query<
        GetVehiclesWithDriversApiResponse,
        GetVehiclesWithDriversApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-06-17/vehicles/withDrivers`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['header_cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            vehicleSearchKeyword: queryArg.vehicleSearchKeyword,
            page: queryArg.page,
            'cs-continuation-token': queryArg['query_cs-continuation-token'],
          },
        }),
        providesTags: ['Vehicles'],
      }),
      listVehicleBoardingSessions: build.query<
        ListVehicleBoardingSessionsApiResponse,
        ListVehicleBoardingSessionsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-05-21/boarding/vehicleBoardingSessions`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            batchId: queryArg.batchId,
            organizationId: queryArg.organizationId,
            size: queryArg.size,
            sessionType: queryArg.sessionType,
            vin: queryArg.vin,
            token: queryArg.token,
          },
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      getOilLifeSummaryMetrics: build.query<
        GetOilLifeSummaryMetricsApiResponse,
        GetOilLifeSummaryMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-05-06/views/oilLifeDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      getDiagnosticsSummaryMetrics: build.query<
        GetDiagnosticsSummaryMetricsApiResponse,
        GetDiagnosticsSummaryMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-05-06/views/diagnosticDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      getConnectivityStatusSummaryMetrics: build.query<
        GetConnectivityStatusSummaryMetricsApiResponse,
        GetConnectivityStatusSummaryMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-05-06/views/connectivityStatusDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      getChargeLevelSummaryMetrics: build.query<
        GetChargeLevelSummaryMetricsApiResponse,
        GetChargeLevelSummaryMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-05-06/views/chargeLevelDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      getVehiclesBasicDetails: build.query<
        GetVehiclesBasicDetailsApiResponse,
        GetVehiclesBasicDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-04-08/views/vehiclesBasicDetails`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            vins: queryArg.vins,
            name: queryArg.name,
            licensePlate: queryArg.licensePlate,
            sortBy: queryArg.sortBy,
            sortOrder: queryArg.sortOrder,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      searchAsset1: build.query<SearchAsset1ApiResponse, SearchAsset1ApiArg>({
        query: (queryArg) => ({
          url: `/2025-03-11-BETA/search`,
          params: {
            searchText: queryArg.searchText,
            top: queryArg.top,
            skip: queryArg.skip,
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            filters: queryArg.filters,
            queryType: queryArg.queryType,
          },
        }),
        providesTags: ['azure-ai-search-controller'],
      }),
      listIncompleteOnboardingVehicles: build.query<
        ListIncompleteOnboardingVehiclesApiResponse,
        ListIncompleteOnboardingVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-02-25/boarding/vehicles/incomplete`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            vin: queryArg.vin,
            reason: queryArg.reason,
          },
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      getAssetsList: build.query<GetAssetsListApiResponse, GetAssetsListApiArg>(
        {
          query: (queryArg) => ({
            url: `/2025-02-11/views/vehicleList`,
            headers: {
              'cs-organization': queryArg['cs-organization'],
              'cs-fleet': queryArg['cs-fleet'],
              'cs-continuation-token': queryArg['cs-continuation-token'],
            },
            params: {
              size: queryArg.size,
              propulsionTypes: queryArg.propulsionTypes,
              vin: queryArg.vin,
              name: queryArg.name,
              licensePlate: queryArg.licensePlate,
            },
          }),
          providesTags: ['asset-view-controller'],
        }
      ),
      getVehicleIgnitionStatus: build.query<
        GetVehicleIgnitionStatusApiResponse,
        GetVehicleIgnitionStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-02-11/views/vehicleIgnitionStatus/${queryArg.vin}`,
        }),
        providesTags: ['asset-view-controller'],
      }),
      getAssetStatusWithFiltering: build.query<
        GetAssetStatusWithFilteringApiResponse,
        GetAssetStatusWithFilteringApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-02-11/views/status/${queryArg.id}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            statuses: queryArg.statuses,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      listPendingOnboardingVehicles: build.query<
        ListPendingOnboardingVehiclesApiResponse,
        ListPendingOnboardingVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-02-11/boarding/vehicles/pending`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            status: queryArg.status,
            vin: queryArg.vin,
            reviewReasons: queryArg.reviewReasons,
            fan: queryArg.fan,
            subscriberAccountNumber: queryArg.subscriberAccountNumber,
            accountOwnerEmailId: queryArg.accountOwnerEmailId,
            stationId: queryArg.stationId,
            vehicleYear: queryArg.vehicleYear,
            vehicleMakes: queryArg.vehicleMakes,
            vehicleModel: queryArg.vehicleModel,
          },
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      executeRemoteCommands: build.query<
        ExecuteRemoteCommandsApiResponse,
        ExecuteRemoteCommandsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-01-14/remotecommands/${queryArg.commandType}/${queryArg.command}/${queryArg.vin}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['remote-command-controller'],
      }),
      getChargeLevelDashboardSummary: build.query<
        GetChargeLevelDashboardSummaryApiResponse,
        GetChargeLevelDashboardSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-11-06/views/chargeLevelDashboardSummary`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      getFieldActionsForVin: build.query<
        GetFieldActionsForVinApiResponse,
        GetFieldActionsForVinApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-09-11/fieldactions/lookup/${queryArg.vin}`,
        }),
        providesTags: ['vehicle-field-action-view-controller'],
      }),
      get20240717ByAssetIdInternal: build.query<
        Get20240717ByAssetIdInternalApiResponse,
        Get20240717ByAssetIdInternalApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-07-17/${queryArg.assetId}/internal`,
          headers: {
            'cs-session-token': queryArg['cs-session-token'],
          },
        }),
        providesTags: ['Asset'],
      }),
      getVehicleBoardingProfile: build.query<
        GetVehicleBoardingProfileApiResponse,
        GetVehicleBoardingProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-06-10/boarding/vehicles/${queryArg.vin}`,
        }),
        providesTags: ['vehicle-boarding-profile-controller'],
      }),
      getCurrentVehicleBoardingSession: build.query<
        GetCurrentVehicleBoardingSessionApiResponse,
        GetCurrentVehicleBoardingSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-06-10/boarding/vehicles/${queryArg.vin}/sessions/current`,
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      getVehicleBoardingSessionBySessionId: build.query<
        GetVehicleBoardingSessionBySessionIdApiResponse,
        GetVehicleBoardingSessionBySessionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-06-10/boarding/vehicleBoardingSessions/${queryArg.sessionId}`,
        }),
        providesTags: ['vehicle-boarding-workflow-session-controller'],
      }),
      getOrganizationIdByAssetId: build.query<
        GetOrganizationIdByAssetIdApiResponse,
        GetOrganizationIdByAssetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-05-10/asset/${queryArg.assetId}/organization`,
        }),
        providesTags: ['asset-controller'],
      }),
      getAssetByIdWithFan: build.query<
        GetAssetByIdWithFanApiResponse,
        GetAssetByIdWithFanApiArg
      >({
        query: (queryArg) => ({ url: `/2023-11-21/${queryArg.id}` }),
        providesTags: ['asset-controller'],
      }),
      getComplianceReportV2: build.query<
        GetComplianceReportV2ApiResponse,
        GetComplianceReportV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/2023-03-14/views/complianceReport`,
          headers: {
            organizationId: queryArg.organizationId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            params: queryArg.params,
          },
        }),
        providesTags: ['compliance-report-view-controller'],
      }),
      getDashboardMetrics: build.query<
        GetDashboardMetricsApiResponse,
        GetDashboardMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/views/orgDashboard`,
          headers: {
            orgId: queryArg.orgId,
            'x-bd-organization': queryArg['x-bd-organization'],
          },
          params: {
            filters: queryArg.filters,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      getMapListItems: build.query<
        GetMapListItemsApiResponse,
        GetMapListItemsApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/views/maplistitems`,
          headers: {
            continuationToken: queryArg.continuationToken,
          },
          params: {
            filters: queryArg.filters,
            size: queryArg.size,
          },
        }),
        providesTags: ['asset-view-controller'],
      }),
      getAssetWithi8NDetails: build.query<
        GetAssetWithi8NDetailsApiResponse,
        GetAssetWithi8NDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/views/enhancements/${queryArg.id}`,
        }),
        providesTags: ['asset-view-controller'],
      }),
      deleteVehicles: build.mutation<
        DeleteVehiclesApiResponse,
        DeleteVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-30/admin/ovi/vehicles`,
          method: 'DELETE',
          params: {
            organizationId: queryArg.organizationId,
            oviAccountId: queryArg.oviAccountId,
          },
        }),
        invalidatesTags: ['ovi-vehicle-migration-test-data-controller'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as assetsApi };
export type UpdateAssetApiResponse =
  /** status 200 OK */ GmResponseCommonAssetResponse;
export type UpdateAssetApiArg = {
  /** Asset's identification. */
  id: string;
  body: UpdateVehicleJson | UpsertVehicleJson;
};
export type DeleteAssetApiResponse = /** status 200 OK */ GmResponseCommonEmpty;
export type DeleteAssetApiArg = {
  /** Asset's identification. */
  id: string;
};
export type ListPartnerVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonPartnerVehicleListResponse;
export type ListPartnerVehiclesApiArg = {
  partnerVehicleListRequest: PartnerVehicleListRequest;
};
export type RepairUpdateDatesApiResponse =
  /** status 200 OK */ GmResponseCommonListRepairUpdateDateResult;
export type RepairUpdateDatesApiArg = {
  repairUpdateDateRequest: RepairUpdateDateRequest;
};
export type ResetFleetTelemetryApiResponse =
  /** status 200 OK */ GmResponseCommonResetFleetTelemetryResponse;
export type ResetFleetTelemetryApiArg = {
  resetFleetTelemetryRequest: ResetFleetTelemetryRequest;
};
export type UpdateSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateBatchBoardingSummaryResponse;
export type UpdateSummaryApiArg = {
  summaryId: string;
};
export type UpdateSessionApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateBoardingSessionResponse;
export type UpdateSessionApiArg = {
  sessionId: string;
};
export type UpdateVehicleApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateVehicleGmVehicleResponse20260224;
export type UpdateVehicleApiArg = {
  vin: string;
};
export type UpdateVehicle1ApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateConnectivityProviderResponse;
export type UpdateVehicle1ApiArg = {
  vin: string;
};
export type UpdateVehicle2ApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateClaimedOnstarResponse;
export type UpdateVehicle2ApiArg = {
  vin: string;
};
export type UpdateVehicleBatchApiResponse =
  /** status 200 OK */ GmResponseCommonListUpdateClaimedOnstarResponse;
export type UpdateVehicleBatchApiArg = {
  body: string[];
};
export type UpdateVehicle3ApiResponse =
  /** status 200 OK */ GmResponseCommonUpdateVehicleOnStarSupportStatusResponse;
export type UpdateVehicle3ApiArg = {
  vin: string;
};
export type ExecuteRemoteCommandsMfaApiResponse =
  /** status 200 OK */ GmResponseCommonOptionalRemoteCommandResponse;
export type ExecuteRemoteCommandsMfaApiArg = {
  /**     The type of command to be executed. Permissible values are:
        - engine
        - door
        - alert
        - ignition
     */
  commandType: 'ENGINE' | 'DOOR' | 'ALERT' | 'IGNITION' | 'VEHICLE';
  /**     The specific action to be performed. Permissible values by command type:
        - engine: start, cancel
        - door: lock, unlock
        - alert: start, cancel
        - ignition: enable, disable
     */
  command:
    | 'START'
    | 'CANCEL'
    | 'LOCK'
    | 'UNLOCK'
    | 'ENABLE'
    | 'DISABLE'
    | 'CONNECT';
  /** VIN of the vehicle on which the command is to be executed. */
  vin: string;
  /** The organization Id. */
  'cs-organization': string;
  /** Unique device fingerprint used for step-up MFA and trusted device recognition. */
  'X-Device-Fingerprint'?: any;
  /** Client application or browser identifier used for trusted device identification. */
  'User-Agent'?: any;
  /** OTP payload for step-up MFA verification. */
  otpPayload: OtpPayload;
};
export type ResetVehiclesApiResponse =
  /** status 200 Reset results returned (check per-entry status). */ GmResponseCommonResetVehiclesOviMigrationResponse;
export type ResetVehiclesApiArg = {
  resetVehiclesOviMigrationRequest: ResetVehiclesOviMigrationRequest;
};
export type CleanupFakeVinsApiResponse =
  /** status 200 Cleanup results returned (check per-entry status). */ GmResponseCommonCleanupFakeVinsResponse;
export type CleanupFakeVinsApiArg = {
  cleanupFakeVinsRequest: CleanupFakeVinsRequest;
};
export type OffboardAllOrganizationVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonOrganizationVehicleOffboardResponse;
export type OffboardAllOrganizationVehiclesApiArg = {
  /** The ID of the organization to off-board. */
  organizationId: string;
  /** Identifies this close attempt. Its batches are recorded against it. */
  'cs-idempotency-key': string;
};
export type BulkGetOviVehiclesApiResponse =
  /** status 200 Successfully retrieved basic OVI vehicle info. */ GmResponseCommonMapStringBasicOviVehicleInfo;
export type BulkGetOviVehiclesApiArg = {
  /** The organization Id. */
  'cs-organization': string;
  /** The fleet Id (optional). */
  'cs-fleet'?: string;
  bulkGetOviVehiclesRequest: BulkGetOviVehiclesRequest;
};
export type ValidateVehiclesApiResponse =
  /** status 200 Successfully validated OVI vehicles. */ GmResponseCommonValidateMigratedOviVehiclesResponse;
export type ValidateVehiclesApiArg = {
  validateMigratedOviVehiclesRequest: ValidateMigratedOviVehiclesRequest;
};
export type SeedVehicleApiResponse =
  /** status 200 OK */ GmResponseCommonVehicle;
export type SeedVehicleApiArg = {
  seedOviTestVehicleRequest: SeedOviTestVehicleRequest;
};
export type OffboardVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonOffboardVehiclesResponse;
export type OffboardVehiclesApiArg = {
  /** UUID of the requesting organization. */
  'cs-organization': string;
  offboardVehiclesRequest: OffboardVehiclesRequest;
};
export type ListVerifiedVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonVerifiedVehiclesListResponse;
export type ListVerifiedVehiclesApiArg = {
  /** UUID of the requesting organization. */
  'cs-organization': string;
  verifiedVehiclesListRequest: VerifiedVehiclesListRequest;
};
export type ListMigratedVehiclesApiResponse =
  /** status 200 Successfully listed migrated OVI vehicles. */ GmResponseCommonGmPageMigratedVehicleDto;
export type ListMigratedVehiclesApiArg = {
  oviAccountId?: string;
  oviFleetId?: string;
  oviVehicleId?: string;
  organizationId?: string;
  fleetId?: string;
  assetId?: string;
  size?: number;
  'cs-continuation-token'?: string;
};
export type SyncVehiclesApiResponse =
  /** status 200 Successfully synced OVI vehicles. */ GmResponseCommonSyncOviVehiclesResponse;
export type SyncVehiclesApiArg = {
  /** If true, forces the change regardless of existing state. */
  'FORCE-CHANGE'?: boolean;
  syncOviVehiclesRequest: SyncOviVehiclesRequest;
};
export type SubscriptionOnboardVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingResponse;
export type SubscriptionOnboardVehiclesApiArg = {
  /** The boarding organization ID. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet': string;
  /** Desired subscription state: ACTIVE or INACTIVE. May be null or omitted to
    skip subscription management. */
  subscriptionState?: 'ACTIVE' | 'INACTIVE';
  /** Subscription organization ID. Required when subscriptionState is ACTIVE or INACTIVE. */
  subscriptionOrgId?: string;
  /** API plan code. Required only when subscriptionState is ACTIVE. */
  planCode?: 'API_STARTER' | 'API_PRO' | 'API_ELITE';
  /** List of API service codes. Used only when subscriptionState is ACTIVE. */
  serviceCodes?: (
    | 'DTC_NOTIFICATION'
    | 'EV_PHEV_DATA'
    | 'HARD_ACCELERATION'
    | 'HARD_BRAKE'
    | 'INCAB_ALERTS'
    | 'PREDELIVERY'
    | 'TELEMETRY'
  )[];
  body: {
    file: Blob;
  };
};
export type SubscriptionOffboardVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingResponse;
export type SubscriptionOffboardVehiclesApiArg = {
  /** The boarding organization ID. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet': string;
  body: {
    file: Blob;
  };
};
export type ExportVehicleListOverviewCsvFromSearchApiResponse =
  /** status 200 OK */ string;
export type ExportVehicleListOverviewCsvFromSearchApiArg = {
  /** The organization Id. */
  'cs-organization'?: string;
  /** The fleet Id. */
  'cs-fleet'?: string;
  timezone?: string;
  vehicleOverviewSearchRequest: VehicleOverviewSearchRequest;
};
export type BulkGetVehicleBasicInfoApiResponse =
  /** status 200 OK */ GmResponseCommonMapStringVehicleBasicInfoResponse;
export type BulkGetVehicleBasicInfoApiArg = {
  /** The organization Id. */
  'cs-organization': string;
  /** The fleet Id (optional). */
  'cs-fleet'?: string;
  bulkGetVehicleBasicInfoRequest: BulkGetVehicleBasicInfoRequest;
};
export type GetVehicleOverviewListApiResponse =
  /** status 200 OK */ GmResponseCommonAzureAiSearchResponseVehicleOverviewSearchResult;
export type GetVehicleOverviewListApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  vehicleOverviewSearchRequest: VehicleOverviewSearchRequest;
};
export type ExportVehicleDiagnosticsListApiResponse =
  /** status 200 OK */ string;
export type ExportVehicleDiagnosticsListApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  timezone?: string;
  locale?: string;
  timeZone?: string;
  distanceUnit?: string;
  bdPageRequest: BdPageRequest;
};
export type GetAssetBatteryReadinessV20260113ApiResponse =
  /** status 200 OK */ GmResponseCommonBatteryReadinessItemsResponsePageV20250211;
export type GetAssetBatteryReadinessV20260113ApiArg = {
  /** The organization ID. */
  'cs-organization'?: string;
  /** The fleet ID. */
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type ExportAssetBatteryReadinessCsvV20260113ApiResponse =
  /** status 200 OK */ string;
export type ExportAssetBatteryReadinessCsvV20260113ApiArg = {
  /** The organization ID. */
  'cs-organization'?: string;
  /** The fleet ID. */
  'cs-fleet'?: string;
  /** The request body containing the filter criteria  */
  requestBody?: any;
  locale?: string;
  timeZone?: string;
  distanceUnit?: string;
  bdPageRequest: BdPageRequest;
};
export type GetVehiclesWithDriversAndPeripheralsUsingBdQueryApiResponse =
  /** status 200 OK */ GmResponseCommonRetrieveVehiclesWithDriversAndPeripheralsResponse;
export type GetVehiclesWithDriversAndPeripheralsUsingBdQueryApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
  bdPageRequest: BdPageRequest;
};
export type ProbeVehicleApiResponse =
  /** status 200 Success */ GmResponseCommonBoolean;
export type ProbeVehicleApiArg = {
  /** The VIN of a vehicle to probe */
  vin: string;
};
export type GetVehiclesWithDriversAndPeripheralsApiResponse =
  /** status 200 OK */ GmResponseCommonRetrieveVehiclesWithDriversAndPeripheralsResponse;
export type GetVehiclesWithDriversAndPeripheralsApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items to return (default 20). */
  size?: number;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
  vehiclesWithDriversAndPeripheralsRequest: VehiclesWithDriversAndPeripheralsRequest;
};
export type ChangeFleetForVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonChangeFleetResponse;
export type ChangeFleetForVehiclesApiArg = {
  'cs-organization': string;
  changeFleetRequest: ChangeFleetRequest;
};
export type CancelBatchApiResponse =
  /** status 200 OK */ GmResponseCommonCancelBatchResponse;
export type CancelBatchApiArg = {
  /** The id of the organization. */
  'cs-organization': string;
  /** The ID of the batch to cancel. */
  batchId: string;
};
export type ExportVehicleListOverviewCsvApiResponse =
  /** status 200 OK */ string;
export type ExportVehicleListOverviewCsvApiArg = {
  /** The organization Id. */
  'cs-organization'?: string;
  /** The fleet Id. */
  'cs-fleet'?: string;
  timezone?: string;
  locale?: string;
  timeZone?: string;
  distanceUnit?: string;
  bdPageRequest: BdPageRequest;
};
export type GetVehicleOverviewList1ApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseVehicleListOverview;
export type GetVehicleOverviewList1ApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type GetVehicleDiagnosticsListApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseVehicleDiagnosticsList;
export type GetVehicleDiagnosticsListApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type ExportPendingConnectionVehiclesApiResponse =
  /** status 200 OK */ string;
export type ExportPendingConnectionVehiclesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items per page. */
  size?: number;
  /** Filter by (partial) VIN. */
  vin?: any;
  /** Filter by (partial) OnStar subscriber account number. */
  subscriberAccountNumber?: string;
  /** Filter by (partial) OnStar account owner email ID. */
  accountOwnerEmailId?: string;
  /** Filter by (partial) FAN (Factory Assigned Number). */
  fan?: string;
  /** Filter by (partial) OnStar station ID. */
  stationId?: string;
  /** Filter by pending connection statuses. */
  pendingConnectionStatuses?: (
    | 'TERMS_NOT_SIGNED'
    | 'UNIT_STATE_NOT_CONFIGURED'
    | 'UNIT_STATE_DISABLED'
    | 'GRANT_CONSENT_REQUEST_PENDING'
    | 'GRANT_CONSENT_REQUEST_FAILED'
    | 'GRANT_CONSENT_REQUEST_REJECTED'
    | 'ENROLL_TASKS_PENDING'
    | 'ENROLL_TASKS_FAILED'
    | 'NOT_DEFINED'
  )[];
  /** Optional repeatable filter by advisor connectivity issue category. Values: PENDING_30_MINUTES_TO_ONE_HOUR, PENDING_ONE_HOUR_TO_ONE_DAY, PENDING_OVER_ONE_DAY, RETRIES_STOPPED. Multiple values use OR semantics within the issue category group; omitted or empty disables this filter. Composed with other query filters using AND.
   */
  connectivityIssueCategories?: (
    | 'PENDING_30_MINUTES_TO_ONE_HOUR'
    | 'PENDING_ONE_HOUR_TO_ONE_DAY'
    | 'PENDING_OVER_ONE_DAY'
    | 'RETRIES_STOPPED'
  )[];
  /** Filter by vehicle year. */
  vehicleYear?: string;
  /** Filter by vehicle makes. */
  vehicleMakes?: ('GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET')[];
  /** Filter by (partial) vehicle model. */
  vehicleModel?: string;
  pendingVehicleExportRequest: PendingVehicleExportRequest;
};
export type ExportPendingOnboardingVehiclesApiResponse =
  /** status 200 OK */ string;
export type ExportPendingOnboardingVehiclesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items per page. */
  size?: number;
  /** Filter by status. */
  status?: 'PREPARING' | 'REVIEWING_OWNERSHIP';
  /** Filter by request review reasons. */
  reviewReasons?: (
    | 'ONSTAR_ACCOUNT_NO_OWNER_EMAIL'
    | 'ONSTAR_ACCOUNT_NOT_ACTIVE'
    | 'ONSTAR_ACCOUNT_NOT_FOUND'
    | 'ONSTAR_NOT_SUPPORTED'
    | 'ONSTAR_FLEET_ACCOUNT_NO_FAN'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_GEN_NOT_SUPPORTED'
    | 'NO_MATCHING_ONSTAR_ACCOUNT_EMAIL'
    | 'NO_MATCHING_FAN'
    | 'VEHICLE_POWERTRAIN_NOT_SUPPORTED'
    | 'VEHICLE_ACCOUNT_TYPE_NOT_SUPPORTED'
    | 'UNEXPECTED'
    | 'ONSTAR_NOT_AVAILABLE'
  )[];
  /** Filter by (partial) FAN. */
  fan?: string;
  /** Filter by (partial) OnStar subscriber account number. */
  subscriberAccountNumber?: string;
  /** Filter by (partial) OnStar email. */
  accountOwnerEmailId?: string;
  /** Filter by (partial) OnStar station ID. */
  stationId?: string;
  /** Filter by vehicle year. */
  vehicleYear?: string;
  /** Filter by vehicle makes. */
  vehicleMakes?: ('GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET')[];
  /** Filter by (partial) vehicle model. */
  vehicleModel?: string;
  pendingVehicleExportRequest: PendingVehicleExportRequest;
};
export type RefreshBatchSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingResponse;
export type RefreshBatchSummaryApiArg = {
  /** The id of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The ID of the batch to refresh. */
  batchId: string;
};
export type GetAssetReadinessV20250909ApiResponse =
  /** status 200 OK */ GmResponseCommonAssetReadinessEnhancedDiagnosticsItemResponsePageV20241203;
export type GetAssetReadinessV20250909ApiArg = {
  'cs-organization'?: string;
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type ExportAssetReadinessCsvV20250909ApiResponse =
  /** status 200 OK */ string;
export type ExportAssetReadinessCsvV20250909ApiArg = {
  /** The organization ID. */
  'x-bd-organization'?: any;
  /** The fleet ID. */
  'x-bd-fleet'?: any;
  /** The request body containing the filter criteria  */
  requestBody?: any;
  /** Locale from user preferences used to localize CSV headers (e.g. en-US, fr-CA). Defaults to en-US when omitted. */
  locale?: string;
  /** IANA time zone for date/time formatting (e.g. America/New_York). Defaults to UTC. */
  timeZone?: string;
  /** Optional distance unit (MeasurementUnit code, e.g. KILOMETER, MILE). Defaults from locale. */
  distanceUnit?: string;
  'cs-organization'?: string;
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type ExportAssetFluidReadinessCsvV20250909ApiResponse =
  /** status 200 OK */ string;
export type ExportAssetFluidReadinessCsvV20250909ApiArg = {
  /** The organization ID. */
  'x-bd-organization'?: any;
  /** The fleet ID. */
  'x-bd-fleet'?: any;
  /** The request body containing the filter criteria  */
  requestBody?: any;
  /** Locale from user preferences used to localize CSV headers (e.g. en-US, fr-CA). Defaults to en-US when omitted. */
  locale?: string;
  /** IANA time zone for date/time formatting (e.g. America/New_York). Defaults to UTC. */
  timeZone?: string;
  /** Optional distance unit (MeasurementUnit code, e.g. KILOMETER, MILE). Defaults from locale. */
  distanceUnit?: string;
  'cs-organization'?: string;
  'cs-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type MigratePreviouslyConnectedVehicleToConnectivityApiResponse =
  /** status 200 OK */ GmResponseCommonRestartConnectivityResponse;
export type MigratePreviouslyConnectedVehicleToConnectivityApiArg = void;
export type GetBatchIgnitionStatusApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleListIgnitionStatusResponse;
export type GetBatchIgnitionStatusApiArg = {
  /** JSON payload containing a list of vehicle VINs. */
  vehicleIgnitionStatusBatchRequest: VehicleIgnitionStatusBatchRequest;
};
export type ArchiveVehicleBoardingSessionApiResponse =
  /** status 200 OK */ GmResponseCommonBoolean;
export type ArchiveVehicleBoardingSessionApiArg = {
  /** Boarding session ID */
  sessionId: string;
  vin: string;
};
export type SendConnectivityRestartRequestApiResponse =
  /** status 200 Success */ GmResponseCommonRestartConnectivityResponse;
export type SendConnectivityRestartRequestApiArg = {
  /** Contains list of vins to process and their connectivity types. */
  connectivityRestartRequest?: any;
  restartConnectivityRequest: RestartConnectivityRequest;
};
export type RetryOnboardingVehiclesApiResponse =
  /** status 202 Accepted */ GmResponseCommonRetryOnboardingVehicleBatchResponse;
export type RetryOnboardingVehiclesApiArg = {
  /** JSON payload containing a list of vehicle VINs. */
  retryOnboardingVehicleBatchRequest: RetryOnboardingVehicleBatchRequest;
};
export type TriggerSearchIndexRefreshApiResponse =
  /** status 200 Success */ GmResponseCommonVoid;
export type TriggerSearchIndexRefreshApiArg = {
  /** List of asset IDs to refresh in the search index */
  assetIds?: any;
  /** Batch size for processing the asset IDs */
  batchSize?: number;
  /** Type of data to refresh: DETAILS (asset metadata), TELEMETRY (status fields), or ALL (both). Default: DETAILS */
  typeToRefresh?: 'METADATA' | 'TELEMETRY' | 'ALL';
  body: string[];
};
export type CancelSessionsApiResponse =
  /** status 200 OK */ GmResponseCommonCancelConnectivitySessionResponse;
export type CancelSessionsApiArg = {
  cancelConnectivitySessionRequest: CancelConnectivitySessionRequest;
};
export type GetMapAssetDetailsApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseVehicleListMapsResponse;
export type GetMapAssetDetailsApiArg = {
  'cs-organization': string;
  'cs-fleet'?: string;
  'cs-continuation-token'?: string;
  vehicleListMapsRequest: VehicleListMapsRequest;
};
export type GetMapLocationSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleLocationMapsResponse;
export type GetMapLocationSummaryApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  'cs-fleet'?: string;
  vehicleLocationMapsRequest: VehicleLocationMapsRequest;
};
export type TerminateVehicleBoardingSessionApiResponse =
  /** status 200 OK */ GmResponseCommonBoolean;
export type TerminateVehicleBoardingSessionApiArg = {
  /** Boarding session ID */
  sessionId: string;
  vin: string;
};
export type BatchOffBoardVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingResponse;
export type BatchOffBoardVehiclesApiArg = {
  /** The id of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The provider of the asset remote commands. */
  remoteProvider?: string;
  /** The provider of the asset telemetry data. */
  telemetryProvider?: string;
  /** The type of upload: 'MANUAL' or 'FILE'. Defaults to 'MANUAL'. */
  uploadType?: 'MANUAL' | 'FILE' | 'AUTO_ONBOARDING';
  body: {
    file: Blob;
  };
};
export type RefreshVehicleDataApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleDataRefreshResponse;
export type RefreshVehicleDataApiArg = {
  /** Dry run mode. If true, the refresh will be simulated and intended changes are logged
    without making actual changes.
     */
  dryRun?: boolean;
  /** If true, after a successful refresh the worker cancels any pending grant consent and
    enroll sessions and forces a new OnStar grant consent, even when consent is ACTIVE.
    A successful grant re-runs enrollment. Skipped on dryRun.
     */
  restartConsent?: boolean;
  /** If true, after a successful refresh the worker restarts connectivity enrollment, the
    same as the connectivity restart endpoint with type ENROLL. Ignored when
    restartConsent is true. Skipped on dryRun.
     */
  restartEnrollment?: boolean;
  vehicleDataRefreshRequest: VehicleDataRefreshRequest;
};
export type TriggerAddCapabilitiesEventApiResponse =
  /** status 200 OK */ GmResponseCommonEmpty;
export type TriggerAddCapabilitiesEventApiArg = {
  /** The organization ID. */
  organizationId?: any;
  /** List of asset ids to trigger add capability event */
  assetIds?: any;
  /** Batch size for processing the asset ids */
  batchSize?: number;
  'cs-organization': string;
  body: string[];
};
export type BatchOnboardVehiclesV2ApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingResponse;
export type BatchOnboardVehiclesV2ApiArg = {
  /** The id of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet': string;
  /** The provider of the asset remote commands. */
  remoteProvider?: string;
  /** The provider of the asset telemetry data. */
  telemetryProvider?: string;
  /** The type of upload: 'MANUAL' or 'FILE'. Defaults to 'MANUAL'. */
  uploadType?: 'MANUAL' | 'FILE' | 'AUTO_ONBOARDING';
  /** The connection policy for data services enrollment. Only 'LIMITED' and 'STANDARD' are allowed. Defaults to 'STANDARD'. */
  'X-Boarding-Connection-Policy'?: 'STANDARD' | 'LIMITED' | 'CUSTOM';
  body: {
    file: Blob;
  };
};
export type TriggerEventApiResponse =
  /** status 200 OK */ GmResponseCommonEmpty;
export type TriggerEventApiArg = {
  /** List of asset ids to trigger asset creation event */
  assetIds?: any;
  body: string[];
};
export type GetActiveFieldActionVehicleSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleFieldActionSummaryResponse20241204;
export type GetActiveFieldActionVehicleSummaryApiArg = {
  /** Expected organization id for vehicle field action. */
  organizationId?: any;
  /** Request containing fleet id. */
  vehicleFieldActionSummaryRequest?: any;
  'x-bd-organization': string;
  body: VehicleFieldActionSummaryRequest;
};
export type GetAssetReadinessV20241203ApiResponse =
  /** status 200 OK */ GmResponseCommonAssetReadinessEnhancedDiagnosticsItemResponsePageV20241203;
export type GetAssetReadinessV20241203ApiArg = {
  'x-bd-organization'?: string;
  'x-bd-fleet'?: string;
  bdPageRequest: BdPageRequest;
};
export type RejectVehicleProofOfOwnershipApiResponse =
  /** status 202 Accepted */ GmResponseCommonVehicleOwnershipOperationBatchResponse;
export type RejectVehicleProofOfOwnershipApiArg = {
  /** JSON payload containing a list of vehicle entries for which proof
    of ownership needs confirmation.
     */
  vehicleOwnershipOperationBatchRequest: VehicleOwnershipOperationBatchRequest;
};
export type ConfirmVehicleProofOfOwnershipApiResponse =
  /** status 202 Accepted */ GmResponseCommonVehicleOwnershipOperationBatchResponse;
export type ConfirmVehicleProofOfOwnershipApiArg = {
  /** JSON payload containing a list of vehicle entries for which proof
    of ownership needs confirmation.
     */
  vehicleOwnershipOperationBatchRequest: VehicleOwnershipOperationBatchRequest;
};
export type GetFieldActionSummaryReportApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseVehicleFieldActionReportItem;
export type GetFieldActionSummaryReportApiArg = {
  'x-bd-organization'?: string;
  'x-bd-fleet'?: string;
  vehicleFieldActionReportRequest: VehicleFieldActionReportRequest;
};
export type UpsertAssetApiResponse = /** status 200 OK */ GmResponseCommonEmpty;
export type UpsertAssetApiArg = {
  /** Boolean to indicate if the asset is being re-enrolled in telemetry services */
  isReEnrolling: boolean;
  body: UpdateVehicleJson | UpsertVehicleJson;
};
export type GetAssetsByPageApiResponse =
  /** status 200 OK */ GmResponseCommonAssetDetailResponseViewPage;
export type GetAssetsByPageApiArg = {
  bdPageRequest: BdPageRequest;
};
export type DoSubscribeV2ApiResponse = /** status 201 Created */ Empty;
export type DoSubscribeV2ApiArg = {
  eventSubscriptionRequestV2: EventSubscriptionRequestV2;
};
export type GetAssetWithTireReadinessApiResponse =
  /** status 200 OK */ GmResponseCommonTireReadinessItemsResponsePage;
export type GetAssetWithTireReadinessApiArg = {
  bdPageRequest: BdPageRequest;
};
export type SearchAssetsApiResponse =
  /** status 200 OK */ GmResponseCommonAssetDetailResponsePage;
export type SearchAssetsApiArg = {
  bdPageRequest: BdPageRequest;
};
export type UpdateProtectedFieldsForAssetApiResponse =
  /** status 202 Success */ GmResponseCommonAsset;
export type UpdateProtectedFieldsForAssetApiArg = {
  /** Asset ID. */
  headerAssetId?: any;
  /** Request containing the protected fields to update. */
  request?: any;
  pathAssetId: string;
  protectedFieldsUpdateRequest: ProtectedFieldsUpdateRequest;
};
export type ResetOwnershipApiResponse =
  /** status 200 OK */ GmResponseCommonBoolean;
export type ResetOwnershipApiArg = {
  /** Asset's identification. */
  id: string;
};
export type PatchVehicleProbeApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleProbe;
export type PatchVehicleProbeApiArg = {
  /** Vehicle VIN. */
  vin: string;
  vehicleProbe: VehicleProbe;
};
export type ResetOwnership1ApiResponse =
  /** status 200 OK */ GmResponseCommonAssetResponse;
export type ResetOwnership1ApiArg = {
  /** Asset's identification. */
  id: string;
  updateVehicleJson: UpdateVehicleJson;
};
export type PatchVehicleInfoFieldsApiResponse =
  /** status 200 OK */ GmResponseCommonAssetResponse;
export type PatchVehicleInfoFieldsApiArg = {
  /** Asset's identification. */
  id: string;
  upsertVehicleJson: UpsertVehicleJson;
};
export type UpdateConfigurationApiResponse =
  /** status 202 Accepted */ GmResponseCommonEmpty;
export type UpdateConfigurationApiArg = {
  /** query parameters to find assets to update */
  filters: {
    [key: string]: string;
  };
  updateConfigurationJson: UpdateConfigurationJson;
};
export type ListAssetsWithArrayUpdateDateApiResponse =
  /** status 200 OK */ GmResponseCommonLegacyUpdateDateAssetListResponse;
export type ListAssetsWithArrayUpdateDateApiArg = {
  pageSize?: number;
};
export type ListSummariesApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingSummaryListResponse;
export type ListSummariesApiArg = {
  pageSize?: number;
  organizationId?: string;
  'cs-continuation-token'?: string;
};
export type ListSessionsApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleBoardingSessionListResponse;
export type ListSessionsApiArg = {
  pageSize?: number;
  organizationId?: string;
  'cs-continuation-token'?: string;
};
export type ListVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleListResponse20260224;
export type ListVehiclesApiArg = {
  pageSize?: number;
  organizationId?: string;
  'cs-continuation-token'?: string;
};
export type ListVehicles1ApiResponse =
  /** status 200 OK */ GmResponseCommonConnectivityProviderVehicleListResponse;
export type ListVehicles1ApiArg = {
  pageSize?: number;
  organizationId?: string;
  'cs-continuation-token'?: string;
};
export type ListVehicles2ApiResponse =
  /** status 200 OK */ GmResponseCommonClaimedOnstarVehicleListResponse;
export type ListVehicles2ApiArg = {
  pageSize?: number;
};
export type ListVehicles3ApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleListResponse;
export type ListVehicles3ApiArg = {
  pageSize?: number;
  onstarSupportStatus?: string;
  organizationId?: string;
  'cs-continuation-token'?: string;
};
export type GetVehicleImageUrlApiResponse = unknown;
export type GetVehicleImageUrlApiArg = {
  /** Vehicle Identification Number */
  vin: string;
};
export type GetVehicleStatusDashboardSummaryMetricsV20260602ApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleStatusSummary;
export type GetVehicleStatusDashboardSummaryMetricsV20260602ApiArg = {
  /** The ID of the organization for which the bucketed summary is to be fetched. */
  'cs-organization': string;
  /** The fleet ID. */
  'cs-fleet'?: string;
};
export type GetVehicleImageUrlWithParamsApiResponse = unknown;
export type GetVehicleImageUrlWithParamsApiArg = {
  /** Vehicle Identification Number aka Asset ID */
  vin: string;
  /** Size of the image, defaults to XSMALL. */
  size?:
    | 'XXSMALL'
    | 'XSMALL'
    | 'SMALL'
    | 'MEDIUM'
    | 'LARGE'
    | 'XLARGE'
    | 'XXLARGE';
  /** Angle of the vehicle in the photo, defaults to FRONT. */
  angle?: 'FRONT' | 'REAR' | 'DRIVER_SIDE' | 'PASSENGER_SIDE' | 'WHEEL' | 'TOP';
  /** Whether the image has a transparent background, defaults to true */
  isTransparentBackground?: boolean;
};
export type GetPropulsionSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonPropulsionTypeSummaryResponse;
export type GetPropulsionSummaryApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
};
export type ListBatchSummariesApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageBatchBoardingVehicleSummary;
export type ListBatchSummariesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Filter by user ID who created the batch. */
  createdBy?: string;
  /** Filter by batch progress status (IN_PROGRESS, COMPLETED, INCOMPLETE, FAILED). */
  status?:
    | 'INITIALIZING'
    | 'IN_PROGRESS'
    | 'COMPLETED'
    | 'INCOMPLETE'
    | 'FAILED';
  /** Filter by batch boarding type (ONBOARDING, OFFBOARDING). */
  boardingType?: 'ONBOARDING' | 'OFFBOARDING';
  /** Filter by boarding source type (USER, API_PLATFORM, MIGRATION, FLEET_ADAPTER). Accepts multiple values. */
  sourceTypes?: ('API_PLATFORM' | 'FLEET_ADAPTER' | 'MIGRATION' | 'USER')[];
  /** Number of items per page. */
  size?: number;
  /** Used for next set of results */
  'cs-continuation-token'?: string;
};
export type GetBatchSummaryByIdApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingVehicleSummary;
export type GetBatchSummaryByIdApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The ID of the batch. */
  batchId: string;
};
export type GetBatchSessionsByIdApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageBatchSummaryVehicleBoardingSession;
export type GetBatchSessionsByIdApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The ID of the batch. */
  batchId: string;
  /** Optional VIN to search for specific vehicle sessions. */
  vin?: string;
  /** Optional list of statuses to filter sessions. Returns sessions matching any of the provided statuses exactly. Can be provided multiple times, e.g., ?status=PENDING&status=COMPLETED */
  status?: (
    | 'PENDING'
    | 'REVIEW'
    | 'COMPLETED'
    | 'FAILED'
    | 'CANCELED'
    | 'REJECTED'
    | 'OTHER'
  )[];
  /** Number of items per page. */
  size?: number;
  /** Used for next set of results */
  'cs-continuation-token'?: string;
};
export type Get20250923BoardingBatchesByBatchIdExtendedApiResponse =
  /** status 200 OK */ GmResponseCommonBatchBoardingVehicleSummary;
export type Get20250923BoardingBatchesByBatchIdExtendedApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the batch. */
  batchId: string;
};
export type ExportBatchVehiclesToCsvApiResponse = /** status 200 OK */ string;
export type ExportBatchVehiclesToCsvApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The ID of the batch to export. */
  batchId: string;
  /** Optional VIN to search for specific vehicle sessions. */
  vin?: string;
  /** Optional list of statuses to filter sessions. Returns sessions matching any of the provided statuses exactly. Can be provided multiple times, e.g., ?status=PENDING&status=COMPLETED */
  status?: (
    | 'PENDING'
    | 'REVIEW'
    | 'COMPLETED'
    | 'FAILED'
    | 'CANCELED'
    | 'REJECTED'
    | 'OTHER'
  )[];
  /** Locale from user preferences used to localize CSV headers (e.g. en-US, fr-CA). Defaults to en-US when omitted. */
  locale?: string;
  /** IANA time zone for date/time formatting (e.g. America/New_York). Defaults to UTC. */
  timeZone?: string;
  /** Optional distance unit (MeasurementUnit code, e.g. KILOMETER, MILE). Defaults from locale. */
  distanceUnit?: string;
};
export type ListPendingConnectionVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonGmPagePendingConnectionVehicleItemV20250826;
export type ListPendingConnectionVehiclesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items per page. */
  size?: number;
  /** Filter by (partial) VIN. */
  vin?: string;
  /** Filter by (partial) OnStar subscriber account number. */
  subscriberAccountNumber?: string;
  /** Filter by (partial) OnStar account owner email ID. */
  accountOwnerEmailId?: string;
  /** Filter by (partial) FAN (Factory Assigned Number). */
  fan?: string;
  /** Filter by (partial) OnStar station ID. */
  stationId?: string;
  /** Filter by pending connection statuses. */
  pendingConnectionStatuses?: (
    | 'TERMS_NOT_SIGNED'
    | 'UNIT_STATE_NOT_CONFIGURED'
    | 'UNIT_STATE_DISABLED'
    | 'GRANT_CONSENT_REQUEST_PENDING'
    | 'GRANT_CONSENT_REQUEST_FAILED'
    | 'GRANT_CONSENT_REQUEST_REJECTED'
    | 'ENROLL_TASKS_PENDING'
    | 'ENROLL_TASKS_FAILED'
    | 'NOT_DEFINED'
  )[];
  /** Optional repeatable filter by advisor connectivity issue category. Values: PENDING_30_MINUTES_TO_ONE_HOUR, PENDING_ONE_HOUR_TO_ONE_DAY, PENDING_OVER_ONE_DAY, RETRIES_STOPPED. Multiple values use OR semantics within the issue category group; omitted or empty disables this filter. Composed with other query filters using AND.
   */
  connectivityIssueCategories?: (
    | 'PENDING_30_MINUTES_TO_ONE_HOUR'
    | 'PENDING_ONE_HOUR_TO_ONE_DAY'
    | 'PENDING_OVER_ONE_DAY'
    | 'RETRIES_STOPPED'
  )[];
  /** Filter by vehicle year. */
  vehicleYear?: string;
  /** Filter by vehicle makes. */
  vehicleMakes?: ('GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET')[];
  /** Filter by (partial) vehicle model. */
  vehicleModel?: string;
  /** Used for next set of results */
  'cs-continuation-token'?: string;
};
export type GetOilLifeSummaryMetricsV20250826ApiResponse =
  /** status 200 OK */ GmResponseCommonOilLifeSummary;
export type GetOilLifeSummaryMetricsV20250826ApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The the organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetDiagnosticsSummaryMetricsV20250826ApiResponse =
  /** status 200 OK */ GmResponseCommonDiagnosticsSummary;
export type GetDiagnosticsSummaryMetricsV20250826ApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The the organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetConnectivityStatusDashboardSummaryMetricsV20250826ApiResponse =
  /** status 200 OK */ GmResponseCommonConnectivityStatusSummaryV20250826;
export type GetConnectivityStatusDashboardSummaryMetricsV20250826ApiArg = {
  /** A map containing optional filters for the data. */
  filters?: any;
  /** The ID of the organization for which the connectivity status summary metrics is to be fetched. */
  orgId?: any;
  'x-bd-organization': string;
};
export type GetChargeSummaryMetricsV20250826ApiResponse =
  /** status 200 OK */ GmResponseCommonChargeSummary;
export type GetChargeSummaryMetricsV20250826ApiArg = {
  /** The the organization ID. */
  organizationId?: any;
  /** The fleet ID. */
  fleetId?: any;
  'cs-organization': string;
  'cs-fleet'?: string;
};
export type GetSummaryOfBoardingSessionsApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleBoardingWorkflowSessionBatchSummary;
export type GetSummaryOfBoardingSessionsApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** The boarding session's batch identification number. */
  batchId: string;
};
export type SearchAssetApiResponse =
  /** status 200 Successfully searched organizations. */ GmResponseCommonAzureAiSearchResponseAssetEntitlement;
export type SearchAssetApiArg = {
  /** Search text to search for assets. */
  searchText?: string;
  /** Number of items to return. */
  top?: number;
  /** Number of items to skip. */
  skip?: number;
  /** Organization ID. */
  'cs-organization': string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** List of filters to apply to the search.
    Each filter should be a valid OData filter expression.
    Document: https://learn.microsoft.com/en-us/azure/search/search-query-odata-filter
     */
  filters?: string[];
  /** List of fields to select in the search results.
    If not provided, all fields will be returned.
     */
  fieldsToSelect?: string[];
  /** Query type to use for the search.
    Possible values: 'FULL', 'SIMPLE', 'SEMANTIC'.
    Default is 'SIMPLE'.
     */
  queryType?: 'simple' | 'full' | 'semantic';
};
export type GetVehiclesWithDriversApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseVehicleWithDriverResponse;
export type GetVehiclesWithDriversApiArg = {
  /** Filter by organization ID. */
  'cs-organization': string;
  /** Filter by list of fleet ID. */
  'cs-fleet'?: string;
  /** Number of items per page for pagination (min: 1, max: 20, default: 5). */
  size?: number;
  /** Continuation token for pagination. */
  'header_cs-continuation-token'?: any;
  /** Vehicle keyword to search against the vehicle's name. */
  vehicleSearchKeyword?: string;
  page?: number;
  'query_cs-continuation-token'?: string;
};
export type ListVehicleBoardingSessionsApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageVehicleBoardingWorkflowSessionDetail;
export type ListVehicleBoardingSessionsApiArg = {
  /** The boarding session's batch identification number. */
  batchId?: string;
  /** The organization id associated with the session. */
  organizationId: string;
  /** The number of items to return for the request page. */
  size?: number;
  /** The vehicle boarding session type. */
  sessionType?: 'ONBOARDING' | 'OFFBOARDING';
  /** The vehicle's identification number. */
  vin?: string;
  /** The continuation token for the next set of sessions. */
  token?: any;
  /** The continuation token for the next set of sessions. */
  'cs-continuation-token'?: string;
};
export type GetOilLifeSummaryMetricsApiResponse =
  /** status 200 Successfully aggregated diagnostics. */ GmResponseCommonOilLifeSummary;
export type GetOilLifeSummaryMetricsApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetDiagnosticsSummaryMetricsApiResponse =
  /** status 200 Successfully aggregated diagnostics. */ GmResponseCommonDiagnosticsSummary;
export type GetDiagnosticsSummaryMetricsApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetConnectivityStatusSummaryMetricsApiResponse =
  /** status 200 Successfully aggregated connectivity status data. */ GmResponseCommonConnectivityStatusDashboardSummaryItem;
export type GetConnectivityStatusSummaryMetricsApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetChargeLevelSummaryMetricsApiResponse =
  /** status 200 Successfully aggregated charge level data. */ GmResponseCommonChargeLevelDashboardSummaryResponse;
export type GetChargeLevelSummaryMetricsApiArg = {
  /** Optional fleetId for the data. */
  filters?: any;
  /** The organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetVehiclesBasicDetailsApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseBasicVehicleDetails;
export type GetVehiclesBasicDetailsApiArg = {
  /** The number of items to return. Default is 10. */
  size?: number;
  /** List of vehicle identification numbers. */
  vins?: string[];
  /** The vehicle name. */
  name?: string;
  /** The vehicle license plate. */
  licensePlate?: string;
  /** The organization Id. */
  'cs-organization': string;
  /** The fleet Id. */
  'cs-fleet'?: string;
  /** The continuation token. */
  'cs-continuation-token'?: string;
  sortBy?: string;
  sortOrder?: string;
};
export type SearchAsset1ApiResponse =
  /** status 200 Successfully searched organizations. */ GmResponseCommonAzureAiSearchResponseAsset;
export type SearchAsset1ApiArg = {
  /** Search text to search for assets. */
  searchText?: string;
  /** Number of items to return. */
  top?: number;
  /** Number of items to skip. */
  skip?: number;
  /** Organization ID. */
  'cs-organization'?: string;
  /** Fleet ID. */
  'cs-fleet'?: string;
  /** List of filters to apply to the search.
    Each filter should be a valid OData filter expression.
    Document: https://learn.microsoft.com/en-us/azure/search/search-query-odata-filter
     */
  filters?: string[];
  /** Query type to use for the search.
    Possible values: 'FULL', 'SIMPLE', 'SEMANTIC'.
    Default is 'SIMPLE'.
     */
  queryType?: 'simple' | 'full' | 'semantic';
};
export type ListIncompleteOnboardingVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonIncompleteOnboardingVehiclesResponse;
export type ListIncompleteOnboardingVehiclesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items per page. */
  size?: number;
  /** Filter by (partial) VIN. */
  vin?: string;
  /** Filter by reason. */
  reason?:
    | 'UNEXPECTED_FAILURE'
    | 'VEHICLE_REJECTED_ACTIVELY_ONBOARDING'
    | 'VEHICLE_REJECTED_ACTIVELY_OFFBOARDING'
    | 'VEHICLE_REJECTED_CLAIMED_BY_OTHER'
    | 'VEHICLE_REJECTED_CLAIMED_BY_OWNER'
    | 'VEHICLE_REJECTED_DUPLICATE_VIN'
    | 'VEHICLE_REJECTED_NO_INFORMATION_FOUND'
    | 'VEHICLE_REJECTED_INSUFFICIENT_INFORMATION'
    | 'VEHICLE_REJECTED_INVALID_VIN'
    | 'VEHICLE_REJECTED_BATCH_VIN_LIMIT_EXCEEDED'
    | 'VEHICLE_MANUAL_PROOF_OF_OWNERSHIP_REJECTED'
    | 'VEHICLE_REJECTED_NOT_SUPPORTED';
  /** Used for next set of results */
  'cs-continuation-token'?: string;
};
export type GetAssetsListApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseAssetListItem;
export type GetAssetsListApiArg = {
  /** The number of items to return. Default is 10. */
  size?: number;
  /** The propulsion types filter. */
  propulsionTypes?: ('EV' | 'ICE' | 'HEV' | 'PHEV')[];
  /** The vehicle identification number. */
  vin?: string;
  /** The vehicle name. */
  name?: string;
  /** The vehicle license plate. */
  licensePlate?: string;
  /** The organization Id. */
  'cs-organization': string;
  /** The fleet Id. */
  'cs-fleet': string;
  /** The continuation token. */
  'cs-continuation-token'?: string;
};
export type GetVehicleIgnitionStatusApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleIgnitionStatusView;
export type GetVehicleIgnitionStatusApiArg = {
  /** Vehicle Identification Number of the vehicle. */
  vin: string;
};
export type GetAssetStatusWithFilteringApiResponse =
  /** status 200 OK */ GmResponseCommonAssetStatusView;
export type GetAssetStatusWithFilteringApiArg = {
  /** Asset's identification. */
  id: string;
  /** An optional list of statuses to filter the results. */
  statuses?: string[];
  'cs-organization': string;
  'cs-fleet'?: string;
};
export type ListPendingOnboardingVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonPendingOnboardingVehiclesResponse;
export type ListPendingOnboardingVehiclesApiArg = {
  /** The ID of the organization. */
  'cs-organization': string;
  /** The ID of the fleet. */
  'cs-fleet'?: string;
  /** Number of items per page. */
  size?: number;
  /** Filter by status. */
  status?: 'PREPARING' | 'REVIEWING_OWNERSHIP';
  /** Filter by (partial) VIN. */
  vin?: string;
  /** Filter by request review reasons. */
  reviewReasons?: (
    | 'ONSTAR_ACCOUNT_NO_OWNER_EMAIL'
    | 'ONSTAR_ACCOUNT_NOT_ACTIVE'
    | 'ONSTAR_ACCOUNT_NOT_FOUND'
    | 'ONSTAR_NOT_SUPPORTED'
    | 'ONSTAR_FLEET_ACCOUNT_NO_FAN'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_GEN_NOT_SUPPORTED'
    | 'NO_MATCHING_ONSTAR_ACCOUNT_EMAIL'
    | 'NO_MATCHING_FAN'
    | 'VEHICLE_POWERTRAIN_NOT_SUPPORTED'
    | 'VEHICLE_ACCOUNT_TYPE_NOT_SUPPORTED'
    | 'UNEXPECTED'
    | 'ONSTAR_NOT_AVAILABLE'
  )[];
  /** Filter by (partial) FAN. */
  fan?: string;
  /** Filter by (partial) OnStar subscriber account number. */
  subscriberAccountNumber?: string;
  /** Filter by (partial) OnStar email. */
  accountOwnerEmailId?: string;
  /** Filter by (partial) OnStar station ID. */
  stationId?: string;
  /** Filter by vehicle year. */
  vehicleYear?: string;
  /** Filter by vehicle makes. */
  vehicleMakes?: ('GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET')[];
  /** Filter by (partial) vehicle model. */
  vehicleModel?: string;
  /** Used for next set of results */
  'cs-continuation-token'?: string;
};
export type ExecuteRemoteCommandsApiResponse =
  /** status 200 OK */ GmResponseCommonOptionalRemoteCommandResponse;
export type ExecuteRemoteCommandsApiArg = {
  /** The type of command to be executed. Permissible values are:
    engine, door, alert, ignition.
     */
  commandType: 'ENGINE' | 'DOOR' | 'ALERT' | 'IGNITION' | 'VEHICLE';
  /** The specific action to be performed. Permissible values are:
    engine - start, cancel;
    door - lock, unlock;
    alert - start, cancel;
    ignition - enable, disable.
     */
  command:
    | 'START'
    | 'CANCEL'
    | 'LOCK'
    | 'UNLOCK'
    | 'ENABLE'
    | 'DISABLE'
    | 'CONNECT';
  /** VIN of the vehicle on which the command is to be executed. */
  vin: string;
  /** The organization Id. */
  'cs-organization': string;
};
export type GetChargeLevelDashboardSummaryApiResponse =
  /** status 200 OK */ GmResponseCommonChargeLevelDashboardSummaryResponse;
export type GetChargeLevelDashboardSummaryApiArg = {
  /** Optional fleetId. */
  filters?: any;
  /** The the organization ID. */
  organizationId?: any;
  'x-bd-organization': string;
};
export type GetFieldActionsForVinApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleFieldActionDetailsResponse;
export type GetFieldActionsForVinApiArg = {
  vin: string;
};
export type Get20240717ByAssetIdInternalApiResponse =
  /** status 200 OK */ GmResponseCommonAssetResponse;
export type Get20240717ByAssetIdInternalApiArg = {
  /** Asset's identification. This is typically the VIN for vehicles. */
  assetId: string;
  /** Session token used by internal service-to-service calls to read recently-updated records
    (ensures session/consistency for reads after writes).
     */
  'cs-session-token'?: string;
};
export type GetVehicleBoardingProfileApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleBoardingProfileDetail;
export type GetVehicleBoardingProfileApiArg = {
  /** The vehicle's identification number. */
  vin: string;
};
export type GetCurrentVehicleBoardingSessionApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleBoardingWorkflowSessionDetail;
export type GetCurrentVehicleBoardingSessionApiArg = {
  /** The vehicle's identification number. */
  vin: string;
};
export type GetVehicleBoardingSessionBySessionIdApiResponse =
  /** status 200 OK */ GmResponseCommonVehicleBoardingWorkflowSessionDetail;
export type GetVehicleBoardingSessionBySessionIdApiArg = {
  /** ID number for a boarding session */
  sessionId: string;
};
export type GetOrganizationIdByAssetIdApiResponse =
  /** status 200 OK */ GmResponseCommonString;
export type GetOrganizationIdByAssetIdApiArg = {
  /** The asset ID to fetch the corresponding organization ID */
  assetId: string;
};
export type GetAssetByIdWithFanApiResponse =
  /** status 200 OK */ GmResponseCommonAssetByIdDetailResponse;
export type GetAssetByIdWithFanApiArg = {
  /** Asset's identification. */
  id: string;
};
export type GetComplianceReportV2ApiResponse =
  /** status 200 OK */ GmResponseCommonComplianceReportPage;
export type GetComplianceReportV2ApiArg = {
  /** Org/Fleet ids */
  params?: any;
  /** Optional orgId filter. */
  organizationId?: any;
  'x-bd-organization'?: string;
};
export type GetDashboardMetricsApiResponse =
  /** status 200 OK */ GmResponseCommonDashboardSummaryWrapper;
export type GetDashboardMetricsApiArg = {
  /** Filters of orgId/fleetId. */
  filters?: any;
  /** Optional filter for orgId instead of in filters. */
  orgId?: any;
  'x-bd-organization': string;
};
export type GetMapListItemsApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseViewMapListItem;
export type GetMapListItemsApiArg = {
  /** Filters of orgId/fleetId. */
  filters?: any;
  /** number of items to return */
  size?: number;
  /** continuation token for the next set of assets */
  continuationToken?: string;
};
export type GetAssetWithi8NDetailsApiResponse =
  /** status 200 OK */ GmResponseCommonAssetDetailResponseView;
export type GetAssetWithi8NDetailsApiArg = {
  /** Asset's identification. */
  id: string;
};
export type DeleteVehiclesApiResponse =
  /** status 200 OK */ GmResponseCommonVoid;
export type DeleteVehiclesApiArg = {
  organizationId: string;
  oviAccountId: string;
};
export type StatusValueResponse = {
  value?: any;
  deviceTimestamp?: string;
};
export type DiagnosticSubsystem = {
  type?:
    | 'airbag_deployment'
    | 'antilock_brake'
    | 'auxiliary_transmission_pump'
    | 'battery_conditioning'
    | 'charging_cable'
    | 'electric_all_wheel_drive'
    | 'engine_cooling'
    | 'engine_electrical'
    | 'evaporative_emissions'
    | 'exhaust_emissions'
    | 'hybrid_battery'
    | 'hybrid_powertrain'
    | 'lighting'
    | 'motor_control'
    | 'onboard_charging'
    | 'peripheral'
    | 'safety_belt_pretensioner'
    | 'stabilitrak'
    | 'traction_control'
    | 'wireless_communications';
};
export type DiagnosticSystem = {
  type?:
    | 'airbag'
    | 'antilock_braking'
    | 'electric_drive'
    | 'electric_lamps'
    | 'emissions'
    | 'engine_and_transmission'
    | 'high_voltage_battery'
    | 'onstar'
    | 'stability_control';
  subsystems?: DiagnosticSubsystem[];
};
export type DiagnosticsValueResponse = {
  value?: boolean;
  severity?: string;
  severityRank?: number;
  mil?: boolean;
  deviceTimestamp?: string;
  systems?: DiagnosticSystem[];
};
export type StateResponseJson = {
  connectivity?: string;
  diagnostic?: string;
  availability?: string;
  safetyCompliant?: boolean;
  mil?: string;
  provisioning?: string;
  homeLocationCompliant?: boolean;
  chargingScheduleCompliant?: boolean;
  chargeState?: string;
  vehicleIdling?: boolean;
};
export type AssetResponseBase = {
  type: string;
  /** Asset id */
  id?: string;
  fleetId?: string;
  organizationId?: string;
  name?: string;
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  status?: {
    [key: string]: StatusValueResponse;
  };
  diagnostics?: {
    [key: string]: DiagnosticsValueResponse;
  };
  state?: StateResponseJson;
  availabilityState?: string;
  fan?: string;
  vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
  lastModifiedEpoch?: number;
  lastOnboardedDate?: string;
  creationDateTime?: string;
};
export type PropulsionModelBase = {
  vehiclePropulsion: string;
};
export type HvBattery = {
  batteryCapacityKwh?: number;
};
export type Ev = {
  vehiclePropulsion: 'Ev';
} & PropulsionModelBase & {
    hvBattery?: HvBattery;
  };
export type FuelTank = {
  fuelTankCapacityL?: number;
  fuelType?: 'GASOLINE' | 'DIESEL';
};
export type Hev = {
  vehiclePropulsion: 'Hev';
} & PropulsionModelBase & {
    fuelTank?: FuelTank;
  };
export type Ice = {
  vehiclePropulsion: 'Ice';
} & PropulsionModelBase & {
    fuelTank?: FuelTank;
  };
export type Phev = {
  vehiclePropulsion: 'Phev';
} & PropulsionModelBase & {
    hvBattery?: HvBattery;
    fuelTank?: FuelTank;
  };
export type OnStar = {
  supportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  subscriberAccountNumber?: string;
  unitGenerationId?: string;
  unitState?:
    | 'UNKNOWN'
    | 'NOT_EQUIPPED'
    | 'NOT_CONFIGURED'
    | 'DISABLED'
    | 'ENABLED'
    | 'CONNECTED';
  stationId?: string;
  tcpsAccepted?: boolean;
  vduState?:
    | 'UNKNOWN'
    | 'NOT_EQUIPPED'
    | 'NOT_CONFIGURED'
    | 'DISABLED'
    | 'ENABLED'
    | 'CONNECTED';
  accountOwnerProfileId?: string;
  accountOwnerEmailId?: string;
  accountStatus?: string;
  accountCreationDate?: string;
};
export type ConnectivityConsentSession = {
  attemptCount?: number;
  createdAt?: string;
  id?: string;
  lastAttempt?: string;
  statusChangeAt?: string;
  status?: 'COMPLETED' | 'PENDING' | 'REJECTED' | 'FAILED';
  statusReason?:
    | 'CONSENT_GRANTED_SUCCESSFULLY'
    | 'CONSENT_REVOKED_SUCCESSFULLY'
    | 'PENDING_REQUEST_PROCESSING'
    | 'PENDING_ONSTAR_UNIT_CONNECTED'
    | 'PENDING_TCPS_ACCEPTANCE'
    | 'CONNECTIVITY_PROVIDER_NOT_ELIGIBLE'
    | 'ONSTAR_NOT_SUPPORTED'
    | 'ONSTAR_SIM_NOT_SUPPORTED'
    | 'VEHICLE_PROPULSION_MODEL_NOT_SUPPORTED'
    | 'TIMEOUT_WAITING_FOR_ONSTAR_UNIT_TO_BE_CONNECTED'
    | 'TIMEOUT_WAITING_FOR_TCPS_ACCEPTANCE'
    | 'TIMEOUT_WAITING_FOR_GRANT_CONSENT'
    | 'TIMEOUT_WAITING_FOR_REVOKE_CONSENT'
    | 'REVOKE_CONSENT_DECLINED'
    | 'GRANT_CONSENT_DECLINED'
    | 'MISSING_ACCOUNT_NUMBER'
    | 'UNRECOVERABLE_ERROR';
  type?: 'GRANT' | 'REVOKE';
  retailVehicle?: boolean;
  accountNumber?: string;
};
export type ConnectivityConsent = {
  status?: 'ACTIVE' | 'GRANTING' | 'INACTIVE' | 'REVOKING' | 'UNKNOWN';
  session?: ConnectivityConsentSession;
};
export type ConnectivitySessionTask = {
  lastUpdatedDate?: string;
  name?: string;
  sessionId?: string;
  status?: 'CANCELED' | 'FAILED' | 'PENDING' | 'SUCCESS';
  type?: 'ENROLL' | 'UNENROLL';
  downstreamStatus?: string;
  optInDate?: string;
  optInStatus?: string;
};
export type ConnectivitySession = {
  attemptCount?: number;
  createdAt?: string;
  id?: string;
  lastAttempt?: string;
  statusChangeAt?: string;
  status?: 'CANCELED' | 'COMPLETED' | 'FAILED' | 'PENDING';
  type?: 'ENROLL' | 'UNENROLL';
  connectionPolicy?: 'STANDARD' | 'LIMITED' | 'CUSTOM';
  tasks?: ConnectivitySessionTask[];
  recycleCount?: number;
  lastRecycleAt?: string;
};
export type ConnectivityEnrolledTask = {
  enrolledDate?: string;
  name?: string;
};
export type ConnectivityProvider = {
  consent?: ConnectivityConsent;
  connectionStatus?:
    | 'CONNECTED'
    | 'CONNECTING'
    | 'DISCONNECTED'
    | 'DISCONNECTING'
    | 'UNKNOWN';
  session?: ConnectivitySession;
  enrolledTasks?: ConnectivityEnrolledTask[];
  connectingAt?: string;
  connectedAt?: string;
  consentRevoked?: boolean;
  restarted?: boolean;
};
export type AdapterConnectivity = {
  id?: string;
  serialNumber?: string;
  connectionStatus?:
    | 'CONNECTED'
    | 'CONNECTING'
    | 'DISCONNECTED'
    | 'DISCONNECTING'
    | 'UNKNOWN';
  connectedDate?: string;
};
export type TelematicsConnectivity = {
  provider?: 'NONE' | 'ONSTAR' | 'ADAPTER';
  simulate?: boolean;
  onStar?: ConnectivityProvider;
  adapter?: AdapterConnectivity;
};
export type VehicleResponse = {
  type: 'VehicleResponse';
} & AssetResponseBase & {
    /** Vehicle identification number. */
    vin?: string;
    /** License plate of the vehicle. */
    licensePlate?: string;
    /** Manufacturer of the Vehicle. */
    vehicleMake?: string;
    /** Model name of the Vehicle. */
    vehicleModel?: string;
    /** Model year of the Vehicle. */
    vehicleYear?: string;
    /** Platform, Engine, and Gearbox code. */
    peg?: string;
    /** Engine type of the vehicle. */
    propulsionModel?: Ev | Hev | Ice | Phev;
    /** Onstar related data such as account number for the vehicle. */
    onStar?: OnStar;
    /** Telematics connectivity: provider + connectivity details. */
    connectivity?: TelematicsConnectivity;
    /** List of option codes. */
    rpoCodes?: string[];
    /** Trim level, package, and option code. */
    merchandisingModel?: string;
    /** Time value of when the vehicle was delivered. */
    deliveryDate?: string;
    /** Onstar connection status */
    onStarConnectionStatus?:
      | 'CONNECTED'
      | 'CONNECTING'
      | 'DISCONNECTED'
      | 'DISCONNECTING'
      | 'UNKNOWN';
    /** Source of the vehicle image. Will fall back to generated image if it is not set in cosmos */
    vehicleImageSource?: string;
    /** Vehicle capabilities represented as key-value pairs. */
    capabilities?: {
      [key: string]: string;
    };
  };
export type GmResponseError = {
  errorType: 'GENERIC' | 'VALIDATION';
  message: string;
  errorCode: string;
};
export type GmResponseCommonAssetResponse = {
  result?: VehicleResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type Empty = any;
export type GmResponseCommonEmpty = {
  result?: Empty;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ChangeStateRequestJson = {
  /** Current state of the asset */
  current: string;
  /** Desired state of the asset */
  desired: string;
};
export type UpdateAssetJsonBase = {
  type: string;
  id?: string;
  /** Fleet ID for fleet the asset belongs to */
  fleetId?: string;
  /** Organization ID for organization the asset belongs to */
  organizationId?: string;
  /** Asset name */
  name?: string;
  /** Hardware ID of the asset */
  hardwareId?: string;
  /** Organization primary ownership status */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Vehicle account type */
  vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
  /** Boarding session ID */
  boardingSessionId?: string;
  /** Asset capabilities represented as key-value pairs.
    
    Update semantics:
    - null: no change
    - empty map {}: reset (clear all capabilities)
    - non-empty map: merge with existing capabilities
      (incoming keys overwrite existing keys; unspecified keys are preserved)
    
    Full replacement requires a reset ({}) followed by a subsequent update
    with the desired values.
     */
  capabilities?: {
    [key: string]: string;
  };
  changeAvailabilityStateRequest?: ChangeStateRequestJson;
};
export type UpdateVehicleJson = {
  type: 'UpdateVehicleJson';
} & UpdateAssetJsonBase & {
    /** Asset capabilities as a name-value pair */
    capabilities?: {
      [key: string]: string;
    };
    /** Vehicle Identification Number */
    vin?: string;
    /** Vehicle license plate number */
    licensePlate?: string;
    /** Vehicle license plate expiration date */
    licensePlateExpirationDate?: string;
    /** Vehicle manufacturer */
    vehicleMake?: string;
    /** Vehicle model name */
    vehicleModel?: string;
    /** Vehicle model year */
    vehicleYear?: string;
    /** Vehicle image source */
    vehicleImageSource?: string;
    /** Vehicle propulsion system type */
    propulsionModel?: Ev | Hev | Ice | Phev;
    /** OnStar service configuration */
    onStar?: OnStar;
  };
export type VehicleIdleState = {
  isIdle?: boolean;
  timestamp?: string;
};
export type EngineRunTimeState = {
  lifetimeTotalSec?: number;
  lifetimeOffsetSec?: number;
  lastRawEngineRunTimeSec?: number;
  lastResetAt?: string;
  timestamp?: string;
};
export type State = {
  connectivity?: 'online' | 'offline';
  diagnostics?: 'clear' | 'impaired' | 'critical';
  diagnosticsCritical?: boolean;
  diagnosticsImpaired?: boolean;
  prognosticsCritical?: boolean;
  prognosticsImpaired?: boolean;
  availability?: 'in_service' | 'out_of_service';
  safetyCompliant?: boolean;
  provisioning?: 'in_progress' | 'failed' | 'completed';
  mil?: '30_clear' | '10_critical' | '20_impaired';
  homeLocationCompliant?: boolean;
  chargingScheduleCompliant?: boolean;
  chargeState?:
    | 'unplugged'
    | 'plugged'
    | 'charging'
    | 'completed'
    | 'aborted'
    | 'idle';
  vehicleIdleState?: VehicleIdleState;
  engineRunTimeState?: EngineRunTimeState;
  fieldSourceTransactionId?: {
    [key: string]: string;
  };
};
export type StatusItemValueObject = {
  name?: string;
  value?: any;
  deviceTimestamp?: string;
  receivedDateTime?: string;
  sourceTransactionId?: string;
};
export type DiagnosticsItemValue = {
  name?: string;
  value?: boolean;
  severity?: string;
  mil?: boolean;
  deviceTimestamp?: string;
  systems?: DiagnosticSystem[];
  sourceTransactionId?: string;
};
export type UpsertVehicleJson = {
  type: 'UpsertVehicleJson';
} & UpdateAssetJsonBase & {
    /** Asset capabilities as a name-value pair */
    capabilities?: {
      [key: string]: string;
    };
    /** Vehicle Identification Number */
    vin?: string;
    /** Vehicle license plate number */
    licensePlate?: string;
    /** Vehicle license plate expiration date */
    licensePlateExpirationDate?: string;
    /** Vehicle manufacturer */
    vehicleMake?: string;
    /** Vehicle model name */
    vehicleModel?: string;
    /** Vehicle model year */
    vehicleYear?: string;
    /** Vehicle image source */
    vehicleImageSource?: string;
    /** Vehicle propulsion system type */
    propulsionModel?: Ev | Hev | Ice | Phev;
    /** OnStar service configuration */
    onStar?: OnStar;
    /** Fleet Account Number */
    fan?: string;
    /** Provider for telemetry services */
    telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    /** Provider for remote services */
    remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    /** Type of vehicle account */
    accountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
    /** Platform, Engine, and Gearbox code */
    peg?: string;
    /** List of RPO codes */
    rpoCodes?: string[];
    /** Vehicle merchandising model code */
    merchandisingModelCode?: string;
    /** Whether the vehicle is a GM vehicle */
    gmVehicle?: boolean;
    /** Vehicle delivery date */
    deliveryDate?: string;
    /** Connectivity state of the vehicle */
    state?: State;
    /** Any status items on the vehicle */
    statuses?: {
      [key: string]: StatusItemValueObject;
    };
    /** DTCs on the vehicle */
    diagnostics?: {
      [key: string]: DiagnosticsItemValue;
    };
    /** Telematics connectivity information for the vehicle */
    connectivity?: TelematicsConnectivity;
  };
export type VehicleListItem = {
  /** Vehicle identification number. */
  vin?: string;
  /** Vehicle make. */
  make?: string;
  /** Vehicle model. */
  model?: string;
  /** Vehicle model year. */
  modelYear?: number;
  /** Trim level, package, and option code. */
  trim?: string;
};
export type PartnerVehicleListResponse = {
  /** Tax id from the request. */
  taxId?: string;
  /** Organization id from the request. */
  organizationId?: string;
  /** Vehicles currently available in the organization. */
  vinList?: VehicleListItem[];
};
export type GmResponseCommonPartnerVehicleListResponse = {
  result?: PartnerVehicleListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PartnerVehicleListRequest = {
  /** Tax ID of the organization (EIN, RFC, or other country format). */
  taxId: string;
  /** Organization ID to list vehicles for. */
  organizationId: string;
};
export type RepairUpdateDateResult = {
  id?: string;
  outcome?: 'REPAIRED' | 'NOT_ARRAY' | 'NOT_FOUND';
};
export type GmResponseCommonListRepairUpdateDateResult = {
  result?: RepairUpdateDateResult[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RepairUpdateDateRequest = {
  ids: string[];
};
export type ResetFleetTelemetryResponse = {
  successfulVins?: string[];
  failedVins?: string[];
};
export type GmResponseCommonResetFleetTelemetryResponse = {
  result?: ResetFleetTelemetryResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ResetFleetTelemetryRequest = {
  vins: string[];
  /** Action to perform for each VIN. Defaults to SEND_CONNECTIVITY_MESSAGE. */
  action?: 'SEND_CONNECTIVITY_MESSAGE' | 'RECALCULATE_STATUS';
  /** Whether to cancel a pending FLEET_TELEMETRY session before applying the action. When true
    (default), a pending FLEET_TELEMETRY session is canceled first (a pending session for a
    different task fails the VIN). When false, no session is canceled and the action is applied
    directly, allowing the status to be recalculated without cancelling a session. */
  cancelSession?: boolean;
  /** Only applies when action is RECALCULATE_STATUS and cancelSession is true. When true (default),
    the connection status is recalculated only if a pending FLEET_TELEMETRY session was actually
    canceled for the VIN. When false, the status is recalculated regardless of whether a session
    was canceled. */
  requireSessionCancellation?: boolean;
};
export type UpdateBatchBoardingSummaryResponse = {
  summaryId?: string;
  updated?: boolean;
  sourceType?: 'API_PLATFORM' | 'FLEET_ADAPTER' | 'MIGRATION' | 'USER';
  sourceId?: string;
};
export type GmResponseCommonUpdateBatchBoardingSummaryResponse = {
  result?: UpdateBatchBoardingSummaryResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateBoardingSessionResponse = {
  sessionId?: string;
  updated?: boolean;
  sourceType?: 'API_PLATFORM' | 'FLEET_ADAPTER' | 'MIGRATION' | 'USER';
  sourceId?: string;
};
export type GmResponseCommonUpdateBoardingSessionResponse = {
  result?: UpdateBoardingSessionResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateVehicleGmVehicleResponse20260224 = {
  vin?: string;
  updated?: boolean;
  valueAfter?: boolean;
  reason?: string;
};
export type GmResponseCommonUpdateVehicleGmVehicleResponse20260224 = {
  result?: UpdateVehicleGmVehicleResponse20260224;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateConnectivityProviderResponse = {
  vin?: string;
  updated?: boolean;
  providerBefore?: 'NONE' | 'ONSTAR' | 'ADAPTER';
  providerAfter?: 'NONE' | 'ONSTAR' | 'ADAPTER';
  simulate?: boolean;
};
export type GmResponseCommonUpdateConnectivityProviderResponse = {
  result?: UpdateConnectivityProviderResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateClaimedOnstarResponse = {
  vin?: string;
  updated?: boolean;
  providerBefore?: 'NONE' | 'ONSTAR' | 'ADAPTER';
  providerAfter?: 'NONE' | 'ONSTAR' | 'ADAPTER';
};
export type GmResponseCommonUpdateClaimedOnstarResponse = {
  result?: UpdateClaimedOnstarResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonListUpdateClaimedOnstarResponse = {
  result?: UpdateClaimedOnstarResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type UpdateVehicleOnStarSupportStatusResponse = {
  vin?: string;
  updated?: boolean;
  valueBefore?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  valueAfter?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
};
export type GmResponseCommonUpdateVehicleOnStarSupportStatusResponse = {
  result?: UpdateVehicleOnStarSupportStatusResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RemoteCommandError = {
  code?: string;
  description?: string;
};
export type RemoteCommandResponse = {
  requestTime?: string;
  completionTime?: string;
  url?: string;
  status?: string;
  type?: string;
  requestId?: string;
  error?: RemoteCommandError;
  body?: any;
  payload?: any;
  errorDescription?: string;
};
export type GmResponseCommonOptionalRemoteCommandResponse = {
  result?: RemoteCommandResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OtpPayload = {
  otp?: string;
  rememberDevice?: boolean;
};
export type ResetVehiclesOviMigrationResponseEntry = {
  vin?: string;
  oviAccountId?: string;
  status?: 'RESET' | 'SKIPPED' | 'FAILED';
  failureCode?: string;
  failureMessage?: string;
};
export type ResetVehiclesOviMigrationResponse = {
  vins?: ResetVehiclesOviMigrationResponseEntry[];
};
export type GmResponseCommonResetVehiclesOviMigrationResponse = {
  result?: ResetVehiclesOviMigrationResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ResetVehiclesOviMigrationRequest = {
  oviAccountIds: string[];
  vins: string[];
};
export type CleanupFakeVinsResponseEntry = {
  vin?: string;
  status?:
    | 'OFFBOARDED'
    | 'OFFBOARD_PENDING'
    | 'OFFBOARD_FAILED'
    | 'OFFBOARD_SUBMIT_FAILED';
  message?: string;
};
export type CleanupFakeVinsResponse = {
  found?: number;
  offboarded?: number;
  remaining?: number;
  vehicles?: CleanupFakeVinsResponseEntry[];
  deleted?: number;
};
export type GmResponseCommonCleanupFakeVinsResponse = {
  result?: CleanupFakeVinsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CleanupFakeVinsRequest = {
  oviAccountId?: string;
  cspOrganizationId?: string;
};
export type OrganizationVehicleOffboardResponse = {
  /** Ids of the started batches, to poll for progress. Empty when nothing was claimed. */
  batchIds?: string[];
};
export type GmResponseCommonOrganizationVehicleOffboardResponse = {
  result?: OrganizationVehicleOffboardResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BasicOviVehicleInfo = {
  /** Vehicle Identification Number (VIN). */
  vin?: string;
  /** CSP organization ID. */
  organizationId?: string;
  /** CSP fleet ID. */
  fleetId?: string;
  /** OVI business account ID. */
  oviAccountId?: string;
  /** OVI fleet account ID. */
  oviFleetId?: string;
  /** OVI vehicle ID. */
  oviVehicleId?: string;
};
export type GmResponseCommonMapStringBasicOviVehicleInfo = {
  result?: {
    [key: string]: BasicOviVehicleInfo;
  };
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BulkGetOviVehiclesRequest = {
  /** List of Vehicle Identification Numbers (VINs) to get basic OVI vehicle info for. */
  vins: string[];
};
export type ValidateMigratedOviVehiclesResponseError = {
  code?: 'NOT_FOUND' | 'NOT_CLAIMED' | 'INVALID_STATE' | 'INVALID_FIELD';
  field?: string;
  message?: string;
};
export type ValidateMigratedOviVehiclesResponseEntry = {
  valid?: boolean;
  error?: ValidateMigratedOviVehiclesResponseError;
  vin?: string;
};
export type ValidateMigratedOviVehiclesResponse = {
  allOviVinsMatched?: boolean;
  allCspVinsMatched?: boolean;
  vehicles?: ValidateMigratedOviVehiclesResponseEntry[];
};
export type GmResponseCommonValidateMigratedOviVehiclesResponse = {
  result?: ValidateMigratedOviVehiclesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidateMigratedOviVehiclesRequestEntry = {
  vehicleId: string;
  fleetId: string;
  statusCode?: 'active' | 'inactive' | 'retired';
  vin: string;
  licensePlate?: string;
  nickname?: string;
};
export type ValidateMigratedOviVehiclesRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  vehicles: ValidateMigratedOviVehiclesRequestEntry[];
};
export type VehicleSubsystem = {
  type?:
    | 'airbag_deployment'
    | 'antilock_brake'
    | 'auxiliary_transmission_pump'
    | 'battery_conditioning'
    | 'charging_cable'
    | 'electric_all_wheel_drive'
    | 'engine_cooling'
    | 'engine_electrical'
    | 'evaporative_emissions'
    | 'exhaust_emissions'
    | 'hybrid_battery'
    | 'hybrid_powertrain'
    | 'lighting'
    | 'motor_control'
    | 'onboard_charging'
    | 'peripheral'
    | 'safety_belt_pretensioner'
    | 'stabilitrak'
    | 'traction_control'
    | 'wireless_communications';
};
export type PrognosticSystem = {
  type?: 'vehicle_battery';
  subsystems?: VehicleSubsystem[];
};
export type PrognosticsItemValue = {
  name?: string;
  value?: boolean;
  severity?: string;
  severityRank?: number;
  mil?: boolean;
  deviceTimestamp?: string;
  systems?: PrognosticSystem[];
  sourceTransactionId?: string;
};
export type Value = {
  assetId?: string;
  fleetId?: string;
  organizationId?: string;
  properties?: {
    [key: string]: any;
  };
};
export type ConfigurationValue = {
  lastUpdated?: string;
  value?: Value;
};
export type Configuration = {
  desiredConfigurationValue?: ConfigurationValue;
  currentConfigurationValue?: ConfigurationValue;
};
export type Properties = {
  properties?: {
    [key: string]: any;
  };
};
export type AssetBase = {
  type?: string;
  assetClass: string;
  id?: string;
  assetId?: string;
  fleetId?: string;
  organizationId?: string;
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  name?: string;
  offlineAccessToken?: string;
  fan?: string;
  hardwareId?: string;
  dataCommunicationActivityStatus?:
    | 'NOT_PERMITTED'
    | 'PENDING'
    | 'PREPARING'
    | 'ACTIVATING'
    | 'ACTIVATED';
  telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  statuses?: {
    [key: string]: StatusItemValueObject;
  };
  diagnostics?: {
    [key: string]: DiagnosticsItemValue;
  };
  prognostics?: {
    [key: string]: PrognosticsItemValue;
  };
  capabilities?: {
    [key: string]: string;
  };
  configuration?: Configuration;
  properties?: Properties;
  state?: State;
  connectivity?: TelematicsConnectivity;
  createDateTime?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  ready?: 'ready' | 'not_ready' | 'unknown';
  boardingStatus?:
    | 'pending_verification'
    | 'not_equipped'
    | 'pending_connection'
    | 'connected';
  faultCount?: number;
  lastCommunicated?: string;
  boardingSessionId?: string;
  lastOnboardedDate?: string;
  get_etag?: string;
};
export type AssetBaseWrite = {
  type?: string;
  assetClass: string;
  id?: string;
  assetId?: string;
  fleetId?: string;
  organizationId?: string;
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  name?: string;
  offlineAccessToken?: string;
  fan?: string;
  hardwareId?: string;
  dataCommunicationActivityStatus?:
    | 'NOT_PERMITTED'
    | 'PENDING'
    | 'PREPARING'
    | 'ACTIVATING'
    | 'ACTIVATED';
  telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  statuses?: {
    [key: string]: StatusItemValueObject;
  };
  diagnostics?: {
    [key: string]: DiagnosticsItemValue;
  };
  prognostics?: {
    [key: string]: PrognosticsItemValue;
  };
  capabilities?: {
    [key: string]: string;
  };
  configuration?: Configuration;
  properties?: Properties;
  state?: State;
  connectivity?: TelematicsConnectivity;
  createDateTime?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  ready?: 'ready' | 'not_ready' | 'unknown';
  boardingStatus?:
    | 'pending_verification'
    | 'not_equipped'
    | 'pending_connection'
    | 'connected';
  faultCount?: number;
  lastCommunicated?: string;
  boardingSessionId?: string;
  lastOnboardedDate?: string;
  get_etag?: string;
  _ts?: number;
};
export type Error = {
  errorCode?: string;
  message?: string;
};
export type VehicleProbe = {
  sessionId?: string;
  status?: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED';
  attempts?: number;
  lastAttemptedDate?: string;
  startedDate?: string;
  completedDate?: string;
  errors?: Error[];
};
export type SelfServeApiPlatformLicense = {
  subscriptionPlan?: 'API_STARTER' | 'API_PRO' | 'API_ELITE';
  status?: 'PENDING' | 'CREATED' | 'FAILED';
  licenseId?: string;
  licenseStatus?: string;
  requestId?: string;
  statusUrl?: string;
  boardingExternalSessionId?: string;
  attemptCount?: number;
  createdAt?: string;
  updatedAt?: string;
};
export type Vehicle = {
  assetClass: 'Vehicle';
} & AssetBase & {
    telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    vin?: string;
    licensePlate?: string;
    licensePlateExpirationDate?: string;
    vehicleMake?: string;
    vehicleModel?: string;
    vehicleYear?: string;
    vehicleImageSource?: string;
    onStar?: OnStar;
    oviVehicleId?: string;
    oviAccountId?: string;
    oviFleetId?: string;
    oviChangeSequence?: string;
    peg?: string;
    vehiclePropulsionModel?: Ev | Hev | Ice | Phev;
    vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
    vehicleRpoCodes?: string[];
    vehicleMerchandisingModel?: string;
    vehicleProbe?: VehicleProbe;
    selfServeApiPlatformLicense?: SelfServeApiPlatformLicense;
    gmVehicle?: boolean;
    vehicleDeliveryDate?: string;
    availableCommands?: (
      | 'ALERT'
      | 'CANCEL_ALERT'
      | 'START'
      | 'CANCEL_START'
      | 'ENABLE_IGNITION'
      | 'DISABLE_IGNITION'
      | 'LOCK_DOOR'
      | 'UNLOCK_DOOR'
    )[];
  };
export type VehicleWrite = {
  assetClass: 'Vehicle';
} & AssetBaseWrite & {
    telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
    vin?: string;
    licensePlate?: string;
    licensePlateExpirationDate?: string;
    vehicleMake?: string;
    vehicleModel?: string;
    vehicleYear?: string;
    vehicleImageSource?: string;
    onStar?: OnStar;
    oviVehicleId?: string;
    oviAccountId?: string;
    oviFleetId?: string;
    oviChangeSequence?: string;
    peg?: string;
    vehiclePropulsionModel?: Ev | Hev | Ice | Phev;
    vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
    vehicleRpoCodes?: string[];
    vehicleMerchandisingModel?: string;
    vehicleProbe?: VehicleProbe;
    selfServeApiPlatformLicense?: SelfServeApiPlatformLicense;
    gmVehicle?: boolean;
    vehicleDeliveryDate?: string;
    availableCommands?: (
      | 'ALERT'
      | 'CANCEL_ALERT'
      | 'START'
      | 'CANCEL_START'
      | 'ENABLE_IGNITION'
      | 'DISABLE_IGNITION'
      | 'LOCK_DOOR'
      | 'UNLOCK_DOOR'
    )[];
  };
export type GmResponseCommonVehicle = {
  result?: Vehicle;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonVehicleWrite = {
  result?: VehicleWrite;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SeedOviTestVehicleRequest = {
  vin: string;
  organizationId: string;
  oviAccountId: string;
  oviFleetId: string;
  oviVehicleId?: string;
  name?: string;
  licensePlate?: string;
  vehicleMake?: string;
  organizationPrimaryOwnershipStatus:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
};
export type OffboardVehiclesResponse = {
  /** Number of VINs successfully offboarded. */
  offboardCount?: number;
  /** Total number of VINs that failed to offboard, combining Order Tracking API rejections and activity repository write failures. */
  failedCount?: number;
  /** VINs successfully offboarded. */
  vins?: string[];
  /** VINs that could not be offboarded: ORDERTRACKING VINs rejected by the Order Tracking API, plus any VINs whose activity repository write failed. */
  failedVins?: string[];
};
export type GmResponseCommonOffboardVehiclesResponse = {
  result?: OffboardVehiclesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OffboardVehiclesRequest = {
  /** List of VINs to offboard. An empty array selects all verified vehicles for the organization. Must not exceed 25,000 entries. */
  vins: string[];
};
export type VerifiedVehicleListItem = {
  /** 17-character Vehicle Identification Number. */
  vin?: string;
  /** Model year. Null when metadata is unavailable. */
  year?: number;
  /** Vehicle make. Null when metadata is unavailable. */
  make?: string;
  /** Vehicle model. Null when metadata is unavailable. */
  model?: string;
  /** Vehicle image URL. Default stock url when metadata is unavailable */
  imageUrl?: string;
  /** Data source that identified this vehicle as verified. */
  source?: 'CARPARC' | 'ORDERTRACKING';
};
export type VerifiedVehiclesListResponse = {
  /** Total number of verified vehicles eligible for onboarding or offboarding for this organization. Stable within a sync window unless vehicles are offboarded mid-session. */
  totalCount?: number;
  /** Zero-based offset used to produce this page. */
  offset?: number;
  /** Page size used to produce this page. */
  limit?: number;
  /** Verified vehicle items for the requested page. */
  items?: VerifiedVehicleListItem[];
};
export type GmResponseCommonVerifiedVehiclesListResponse = {
  result?: VerifiedVehiclesListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VerifiedVehiclesListRequest = {
  /** Zero-based page offset. */
  offset?: number;
  /** Maximum number of items to return (0–1000). Use 0 to fetch only totalCount. */
  limit?: number;
  /** Optional partial, case-insensitive search term applied across year, make, model, and VIN. */
  search?: string;
};
export type MigratedVehicleDto = {
  id?: string;
  assetId?: string;
  organizationId?: string;
  fleetId?: string;
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  oviVehicleId?: string;
  oviAccountId?: string;
  oviFleetId?: string;
  oviChangeSequence?: string;
  connectivity?: TelematicsConnectivity;
  state?: State;
  onStar?: OnStar;
  licensePlate?: string;
  name?: string;
  createDateTime?: string;
  updateDate?: string;
};
export type GmPageMigratedVehicleDto = {
  items: MigratedVehicleDto[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageMigratedVehicleDto = {
  result?: GmPageMigratedVehicleDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviVehiclesResponseError = {
  errorCode?: string;
  errorMessage?: string;
  errorContext?: string;
};
export type SyncOviVehiclesResponseEntry = {
  success?: boolean;
  error?: SyncOviVehiclesResponseError;
  assetId?: string;
  vehicleId?: string;
  fleetId?: string;
  changeOp?: 'onboarded' | 'offboarded' | 'changed' | 'no-change';
};
export type SyncOviVehiclesResponse = {
  vehicles?: SyncOviVehiclesResponseEntry[];
};
export type GmResponseCommonSyncOviVehiclesResponse = {
  result?: SyncOviVehiclesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DataChangeTracking = {
  /** HVR change operation indicator. */
  hvrChangeOp: '0' | '1' | '2';
  /** HVR change sequence identifier. */
  hvrChangeSequence: string;
  /** HVR change timestamp. */
  hvrChangeTime: string;
};
export type SyncOviVehicleRequestEntry = {
  /** HVR change operation indicator. */
  hvrChangeOp: '0' | '1' | '2';
  /** HVR change sequence identifier. */
  hvrChangeSequence: string;
  /** HVR change timestamp. */
  hvrChangeTime: string;
  vehicleId: string;
  accountId: string;
  statusCode: 'active' | 'inactive' | 'retired';
  vin: string;
  licensePlate?: string;
  nickname?: string;
  accountVehicleDataChangeTracking: DataChangeTracking;
};
export type SyncOviVehiclesRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  vehicles: SyncOviVehicleRequestEntry[];
};
export type BatchBoardingResponse = {
  batchId?: string;
};
export type GmResponseCommonBatchBoardingResponse = {
  result?: BatchBoardingResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type LastIgnitionFilter = {
  /** Start timestamp for last ignition filter (from) */
  from?: string;
  /** End timestamp for last ignition filter (to) */
  to?: string;
};
export type VehicleListFilter = {
  /** List of boarding statuses to filter by */
  status?: (
    | 'pending_verification'
    | 'not_equipped'
    | 'pending_connection'
    | 'connected'
  )[];
  /** List of VINs to export. When provided, only these vehicles are included. */
  includedVins?: string[];
  /** List of VINs to exclude from export. Used when all are selected and specific rows are deselected. */
  excludedVins?: string[];
  /** Last ignition timestamp range filter with from and to timestamps. */
  lastIgnition?: LastIgnitionFilter;
  /** List of fleet IDs to filter by. When provided, only vehicles in these fleets are returned. */
  fleetIds?: string[];
  /** Location masking filter */
  locationMasking?: ('enabled' | 'disabled')[];
};
export type VehicleOverviewSearchRequest = {
  /** Search term to filter vehicles */
  search?: string;
  /** Type of search query */
  queryType?: 'simple' | 'full' | 'semantic';
  /** Sort order for results */
  sort?: string;
  /** Number of items to skip (for pagination) */
  offset?: number;
  /** Number of items to return per page */
  size?: number;
  /** Filter criteria for vehicle list */
  filter?: VehicleListFilter;
  /** Locale for CSV headers (e.g. en-US, fr-CA). Defaults to en-US. */
  locale?: string;
  /** IANA time zone for date/time formatting in CSV export. Defaults to UTC. */
  timeZone?: string;
  /** Optional distance unit (MeasurementUnit code, e.g. KILOMETER, MILE). Defaults from locale. */
  distanceUnit?: 'KILOMETER' | 'MILE';
};
export type VehicleBasicInfoResponse = {
  /** Vehicle Identification Number (VIN). */
  vin?: string;
  /** CSP fleet ID the vehicle belongs to. */
  fleetId?: string;
  /** Vehicle name. */
  name?: string;
  /** Vehicle make. */
  make?: string;
  /** Vehicle model. */
  model?: string;
  /** Vehicle year. */
  year?: string;
  /** Vehicle propulsion type (e.g. EV, ICE, PHEV). */
  propulsion?: string;
  /** Vehicle image url. */
  imageSource?: string;
};
export type GmResponseCommonMapStringVehicleBasicInfoResponse = {
  result?: {
    [key: string]: VehicleBasicInfoResponse;
  };
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BulkGetVehicleBasicInfoRequest = {
  /** List of Vehicle Identification Numbers (VINs) to get basic info for. */
  vins: string[];
};
export type VehicleOverviewSearchResult = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Organization id */
  organizationId?: string;
  /** Fleet id */
  fleetId?: string;
  /** Fleet Name */
  fleetName?: string;
  /** License plate */
  licensePlate?: string;
  /** Vehicle image source */
  vehicleImageSource?: string;
  /** Manufacturer of the Vehicle */
  make?: string;
  /** Vehicle model */
  model?: string;
  /** Engine type of the vehicle */
  propulsion?: string;
  /** Model year of the Vehicle */
  year?: string;
  /** Connectivity status */
  connectivity?: string;
  /** Unified connection status across OnStar and fleet-adapter providers */
  connectionStatus?:
    | 'NOT_EQUIPPED'
    | 'CONNECTING'
    | 'CONNECTED'
    | 'DISCONNECTING'
    | 'DISCONNECTED';
  /** OnStar support status */
  onStarSupportStatus?: string;
  /** Organization primary ownership status */
  organizationPrimaryOwnershipStatus?: string;
  /** Last onboarded date */
  lastOnboardedDate?: string;
  /** The current state of the OnStar unit */
  onStarUnitState?: string;
  /** Location masking status */
  locationMaskingStatus?: string;
  /** Last ignition time of the vehicle */
  lastIgnition?: string;
  /** Action the end user needs to take next. Always present.
    
    NO_ACTION_REQUIRED and NOT_APPLICABLE are distinct states and must be branched on separately:
    
    - NO_ACTION_REQUIRED: the vehicle is claimed and fully connected. Onboarding succeeded and the user can go explore vehicle data.
    - NOT_APPLICABLE: the pending-action flow does not apply. The vehicle is not equipped, disconnected or disconnecting, or its ownership status is neither CLAIMING nor CLAIMED. Use connectionStatus to tell these apart.
    
    Any other value identifies the specific condition blocking the vehicle, either verification pending (CLAIMING) or connection pending (CLAIMED and still connecting).
     */
  userAction?:
    | 'VERIFICATION_IN_PROGRESS'
    | 'TERMS_NOT_SIGNED'
    | 'UNIT_STATE_NOT_CONFIGURED'
    | 'UNIT_STATE_DISABLED'
    | 'GRANT_CONSENT_REQUEST_PENDING'
    | 'GRANT_CONSENT_REQUEST_FAILED'
    | 'GRANT_CONSENT_REQUEST_REJECTED'
    | 'ENROLL_TASKS_PENDING'
    | 'ENROLL_TASKS_FAILED'
    | 'NOT_DEFINED'
    | 'NO_ACTION_REQUIRED'
    | 'NOT_APPLICABLE';
};
export type AzureAiSearchResponseVehicleOverviewSearchResult = {
  /** List of items returns from search */
  items?: VehicleOverviewSearchResult[];
  /** Total number of items found */
  totalItems?: number;
};
export type GmResponseCommonAzureAiSearchResponseVehicleOverviewSearchResult = {
  result?: AzureAiSearchResponseVehicleOverviewSearchResult;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SortObject = {
  empty?: boolean;
  sorted?: boolean;
  unsorted?: boolean;
};
export type BdQuery = {
  qualifier:
    | 'ALL'
    | 'IS_EQUAL'
    | 'OR'
    | 'AND'
    | 'NOT'
    | 'BEFORE'
    | 'AFTER'
    | 'IN'
    | 'NOT_IN'
    | 'IS_NULL'
    | 'IS_NOT_NULL'
    | 'LESS_THAN'
    | 'LESS_THAN_EQUAL'
    | 'GREATER_THAN'
    | 'GREATER_THAN_EQUAL'
    | 'CONTAINING'
    | 'ENDS_WITH'
    | 'STARTS_WITH'
    | 'TRUE'
    | 'FALSE'
    | 'BETWEEN'
    | 'ARRAY_CONTAINS'
    | 'STRING_EQUALS'
    | 'NOT_CONTAINING';
  field?: string;
  values?: any[];
  leftQuery?: BdQuery;
  rightQuery?: BdQuery;
};
export type BdPageRequest = {
  page: number;
  size: number;
  /** Direct has been deprecated in favor of query. */
  direct?: boolean;
  sort: SortObject[];
  token?: string;
  query?: BdQuery;
};
export type OrganizationResponse = {
  /** Organization id */
  id?: string;
  /** Organization name */
  name?: string;
};
export type FleetResponse = {
  /** Fleet id */
  id?: string;
  /** Fleet name */
  name?: string;
};
export type LastCommunicated = {
  deviceTimestamp?: string;
  status?: 'online' | 'offline';
};
export type BatteryInfo = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  soc?: number;
  targetSoc?: number;
  chargeState?: string;
  estimatedRangedInKM?: number;
  estimatedRangeAtTargetSocInKM?: number;
  estimatedTimeRemainingToTargetSOC?: number;
  chargingPowerInput?: number;
  chargingPowerType?: 'level_1' | 'level_2' | 'dc';
  chargeCompletionTime?: string;
  lifetimeEfficiencyInMpKWH?: number;
  chargePowerType?: 'AC' | 'DC' | 'unknown';
  chargingEstimatedCompletionDateTime?: string;
};
export type VehicleType = {
  /** Manufacturer of the Vehicle. */
  make?: string;
  /** Trim level, package, and option code. */
  merchandisingModel?: string;
  /** Model name of the Vehicle. */
  model?: string;
  /** Platform, Engine, and Gearbox code. */
  peg?: string;
  /** Engine type of the vehicle. */
  propulsion?: 'EV' | 'ICE' | 'HEV' | 'PHEV';
  /** List of option codes. */
  rpoCodes?: string[];
  /** Model year of the Vehicle. */
  year?: string;
};
export type BatteryReadinessItem = {
  id?: string;
  name?: string;
  organization?: OrganizationResponse;
  fleet?: FleetResponse;
  lastCommunicated?: LastCommunicated;
  battery?: BatteryInfo;
  vehicleType?: VehicleType;
  provisioning?: string;
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  tcpsAccepted?: boolean;
  connectivity?: TelematicsConnectivity;
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  boardingStatus?:
    | 'pending_verification'
    | 'not_equipped'
    | 'pending_connection'
    | 'connected';
  licensePlate?: string;
};
export type BatteryReadinessItemsResponsePageV20250211 = {
  items?: BatteryReadinessItem[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonBatteryReadinessItemsResponsePageV20250211 = {
  result?: BatteryReadinessItemsResponsePageV20250211;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PeripheralCountByTypeDto = {
  /** Peripheral type */
  type?: string;
  /** Count of peripherals of this type */
  count?: number;
};
export type AssignedDriver = {
  /** Unique identifier for the driver */
  id?: string;
  /** Driver's full name */
  name?: string;
};
export type VehicleWithDriverAndPeripheralsResponse = {
  /** Vehicle Identification Number (VIN) */
  vin?: string;
  /** Vehicle name */
  name?: string;
  /** Vehicle make */
  make?: string;
  /** Vehicle model */
  model?: string;
  /** Vehicle year */
  year?: string;
  /** Vehicle image source URL */
  imageSourceUrl?: string;
  /** Fleet ID of the vehicle */
  fleetId?: string;
  /** Count of assigned devices grouped by peripheral type */
  assignedDevices?: PeripheralCountByTypeDto[];
  /** Driver assigned to this vehicle */
  assignedDriver?: AssignedDriver;
};
export type RetrieveVehiclesWithDriversAndPeripheralsResponse = {
  items: VehicleWithDriverAndPeripheralsResponse[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonRetrieveVehiclesWithDriversAndPeripheralsResponse =
  {
    result?: RetrieveVehiclesWithDriversAndPeripheralsResponse;
    targetUrl: string;
    __bd: boolean;
    success: boolean;
    unauthorizedRequest: boolean;
    errors: GmResponseError[];
    traceId?: string;
  };
export type GmResponseCommonBoolean = {
  result?: boolean;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehiclesWithDriversAndPeripheralsRequest = {
  /** List of Vehicle Identification Numbers (VINs) to include. Cannot be used together with excludedVins. */
  includedVins?: string[];
  /** List of Vehicle Identification Numbers (VINs) to exclude. Cannot be used together with includedVins. */
  excludedVins?: string[];
};
export type ChangeFleetResponse = {
  failedVins?: string[];
};
export type GmResponseCommonChangeFleetResponse = {
  result?: ChangeFleetResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ChangeFleetRequest = {
  /** List of Vehicle Identification Numbers (VINs) to change fleet. */
  vins?: string[];
  /** The ID of the new fleet to assign the assets to. */
  newFleetId: string;
};
export type BatchBoardingSummaryVehicleEntry = {
  vin?: string;
  status?:
    | 'PENDING'
    | 'REVIEW'
    | 'COMPLETED'
    | 'FAILED'
    | 'CANCELED'
    | 'REJECTED'
    | 'OTHER';
};
export type BatchBoardingVehicleSummary = {
  id?: string;
  organizationId?: string;
  fleetId?: string;
  createdBy?: string;
  createdByName?: string;
  createdByEmail?: string;
  createdDate?: string;
  updatedDate?: string;
  startedDate?: string;
  completedDate?: string;
  status?:
    | 'INITIALIZING'
    | 'IN_PROGRESS'
    | 'COMPLETED'
    | 'INCOMPLETE'
    | 'FAILED';
  batchBoardingType?: 'ONBOARDING' | 'OFFBOARDING';
  uploadType?: 'MANUAL' | 'FILE' | 'AUTO_ONBOARDING';
  totalVehicleCount?: number;
  pendingCount?: number;
  reviewCount?: number;
  completedCount?: number;
  failedCount?: number;
  rejectedCount?: number;
  canceledCount?: number;
  otherCount?: number;
  vehicleBoardingEntries?: BatchBoardingSummaryVehicleEntry[];
  sourceType?: 'API_PLATFORM' | 'FLEET_ADAPTER' | 'MIGRATION' | 'USER';
  sourceId?: string;
  sourceLabel?: string;
  messageReplyTo?: string;
  messageReplyToSessionId?: string;
  messageCorrelationId?: string;
};
export type CancelBatchResponse = {
  /** Indicates whether the cancel operation was performed */
  canceled?: boolean;
  /** Message describing the result of the operation */
  message?: string;
  /** The batch summary containing the current state */
  batchSummary?: BatchBoardingVehicleSummary;
};
export type GmResponseCommonCancelBatchResponse = {
  result?: CancelBatchResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleListOverview = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Organization id */
  organizationId?: string;
  /** Fleet id */
  fleetId?: string;
  /** Fleet Name */
  fleetName?: string;
  /** License plate */
  licensePlate?: string;
  /** Vehicle type */
  vehicleType?: VehicleType;
  /** Connectivity status */
  connectivity?:
    | 'CONNECTED'
    | 'CONNECTING'
    | 'DISCONNECTED'
    | 'DISCONNECTING'
    | 'UNKNOWN';
  /** Unified connection status across OnStar and fleet-adapter providers */
  connectionStatus?:
    | 'NOT_EQUIPPED'
    | 'CONNECTING'
    | 'CONNECTED'
    | 'DISCONNECTING'
    | 'DISCONNECTED';
  /** OnStar support status */
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** Organization primary ownership status */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Vehicle image source */
  vehicleImageSource?: string;
  /** Last onboarded date */
  lastOnboardedDate?: string;
  /** Last communicated date */
  lastCommunicated?: string;
  /** Indicates if TCPS is accepted */
  tcpsAccepted?: boolean;
  /** The current state of the OnStar unit */
  onStarUnitState?:
    | 'UNKNOWN'
    | 'NOT_EQUIPPED'
    | 'NOT_CONFIGURED'
    | 'DISABLED'
    | 'ENABLED'
    | 'CONNECTED';
  /** Last onboarded date based on profile time zone */
  lastOnboardedDateWithProfileTimeZone?: string;
  /** Last communicated date based on profile time zone */
  lastCommunicatedWithProfileTimeZone?: string;
  /** Boarding status of the vehicle */
  boardingStatus?:
    | 'pending_verification'
    | 'not_equipped'
    | 'pending_connection'
    | 'connected';
  /** Location masking state on the vehicle */
  locationMasking?: string;
};
export type PaginatedDataResponseVehicleListOverview = {
  items?: VehicleListOverview[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseVehicleListOverview = {
  result?: PaginatedDataResponseVehicleListOverview;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type StateDiagnostic = {
  state?: string;
  type?: string;
  deviceTimestamp?: string;
  severityRank?: number;
};
export type BatteryInfoJson = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  soc?: number;
  chargeState?: string;
  estimatedRangedInKM?: number;
};
export type FuelLevelJson = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  fuelLevel?: number;
};
export type OilLifeJson = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  oilLife?: number;
};
export type BrakePadJson = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  brakePadLife?: number;
};
export type VehicleDiagnosticsList = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Organization id */
  organizationId?: string;
  /** Fleet id */
  fleetId?: string;
  /** Fleet name */
  fleetName?: string;
  /** License plate */
  licensePlate?: string;
  /** Vehicle type */
  vehicleType?: VehicleType;
  /** Availability state */
  availabilityState?: 'in_service' | 'out_of_service';
  /** Last onboarded date */
  lastOnboardedDate?: string;
  /** Last communicated date */
  lastCommunicated?: string;
  /** Vehicle image source */
  vehicleImageSource?: string;
  /** Indicates if there are critical diagnostics */
  diagnosticsCritical?: boolean;
  /** Indicates if there are impaired diagnostics */
  diagnosticsImpaired?: boolean;
  /** Indicates if there are critical prognostics (predicted faults) */
  prognosticsCritical?: boolean;
  /** List of diagnostics */
  diagnostics?: StateDiagnostic[];
  /** List of prognostics: one entry per open predicted fault, most severe first */
  prognostics?: StateDiagnostic[];
  /** Battery information */
  battery?: BatteryInfoJson;
  /** Fuel level information */
  fuelLevel?: FuelLevelJson;
  /** Oil life information */
  oilLife?: OilLifeJson;
  /** Front brake pad information */
  brakePadFront?: BrakePadJson;
  /** Rear brake pad information */
  brakePadRear?: BrakePadJson;
  /** Engine air filter life */
  engineAirFilterLife?: number;
  /** Engine run time hour */
  engineHour?: number;
  /** Odometer reading */
  odometer?: number;
  /** Last onboarded date based on profile time zone */
  lastOnboardedDateWithProfileTimeZone?: string;
  /** Last communicated date based on profile time zone */
  lastCommunicatedWithProfileTimeZone?: string;
};
export type PaginatedDataResponseVehicleDiagnosticsList = {
  items?: VehicleDiagnosticsList[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseVehicleDiagnosticsList = {
  result?: PaginatedDataResponseVehicleDiagnosticsList;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type LocalizedLabels = {
  reasons?: {
    [key: string]: string;
  };
  connectivityIssueCategories?: {
    [key: string]: string;
  };
  taskStatuses?: {
    [key: string]: string;
  };
  taskHeaders?: {
    [key: string]: string;
  };
};
export type PendingVehicleExportRequest = {
  vins?: string[];
  localizedLabels?: LocalizedLabels;
  /** Locale for CSV headers (e.g. en-US, fr-CA). Defaults to en-US. */
  locale?: string;
  /** IANA time zone for date/time formatting. Defaults to UTC. */
  timeZone?: string;
  /** Optional distance unit (MeasurementUnit code, e.g. KILOMETER, MILE). Defaults from locale. */
  distanceUnit?: 'KILOMETER' | 'MILE';
};
export type EngineAirFilterJson = {
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  engineAirFilter?: number;
  engineAirFilterStatus?:
    | 'replace_now'
    | 'inactive'
    | 'indeterminate'
    | 'missing'
    | 'blocked'
    | 'replace_next_time'
    | 'no_fault'
    | 'unknown';
};
export type AssetReadinessItemEnhancedDiagnostics = {
  /** Asset id */
  id?: string;
  name?: string;
  organization?: OrganizationResponse;
  fleet?: FleetResponse;
  licensePlate?: string;
  lastCommunicated?: LastCommunicated;
  vehicleType?: VehicleType;
  provisioning?: string;
  tcpsAccepted?: boolean;
  connectivity?: TelematicsConnectivity;
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  diagnosticState?: 'clear' | 'impaired' | 'critical';
  diagnosticsCritical?: boolean;
  diagnosticsImpaired?: boolean;
  availabilityState?: 'in_service' | 'out_of_service';
  diagnostics?: StateDiagnostic[];
  battery?: BatteryInfoJson;
  fuelLevel?: FuelLevelJson;
  oilLife?: OilLifeJson;
  brakePadFront?: BrakePadJson;
  brakePadRear?: BrakePadJson;
  engineAirFilter?: EngineAirFilterJson;
  tires?: 'good' | 'impaired' | 'critical' | 'no_data';
  brakeFluid?: 'good' | 'critical' | 'no_data';
  washerFluid?: 'good' | 'impaired' | 'no_data';
  milState?: string;
};
export type AssetReadinessEnhancedDiagnosticsItemResponsePageV20241203 = {
  items?: AssetReadinessItemEnhancedDiagnostics[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonAssetReadinessEnhancedDiagnosticsItemResponsePageV20241203 =
  {
    result?: AssetReadinessEnhancedDiagnosticsItemResponsePageV20241203;
    targetUrl: string;
    __bd: boolean;
    success: boolean;
    unauthorizedRequest: boolean;
    errors: GmResponseError[];
    traceId?: string;
  };
export type RestartConnectivityError = {
  code?: string;
  message?: string;
};
export type RestartConnectivityResponseEntry = {
  /** Vehicle Identification Number from the request entry */
  vin?: string;
  /** Type of connectivity operation requested */
  type?: 'ENROLL' | 'UNENROLL';
  /** Indicates if the connectivity restart operation was successfully sent for processing */
  success?: boolean;
  unitGenId?: string;
  /** Details of any error that occurred during the connectivity restart processing for this VIN */
  error?: RestartConnectivityError;
  ev?: boolean;
};
export type RestartConnectivityResponse = {
  entries?: RestartConnectivityResponseEntry[];
};
export type GmResponseCommonRestartConnectivityResponse = {
  result?: RestartConnectivityResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleIgnitionStatus = {
  vin?: string;
  status?: 'ENABLED' | 'DISABLED' | 'UNKNOWN';
};
export type VehicleListIgnitionStatusResponse = {
  ignitionStatuses?: VehicleIgnitionStatus[];
};
export type GmResponseCommonVehicleListIgnitionStatusResponse = {
  result?: VehicleListIgnitionStatusResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleIgnitionStatusBatchRequest = {
  vins: string[];
};
export type RestartConnectivityRequestEntry = {
  vin: string;
  type: 'ENROLL' | 'UNENROLL';
};
export type RestartConnectivityRequest = {
  entries?: RestartConnectivityRequestEntry[];
};
export type EntryError = {
  code?: string;
  message?: string;
};
export type RetryOnboardingVehicleResponse = {
  vin?: string;
  success?: boolean;
  error?: EntryError;
};
export type RetryOnboardingVehicleBatchResponse = {
  entries?: RetryOnboardingVehicleResponse[];
};
export type GmResponseCommonRetryOnboardingVehicleBatchResponse = {
  result?: RetryOnboardingVehicleBatchResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RetryOnboardingVehicleBatchRequest = {
  vins: string[];
};
export type GmResponseCommonVoid = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CancelConnectivitySessionResponse = {
  successfulVins?: string[];
  failedVins?: string[];
};
export type GmResponseCommonCancelConnectivitySessionResponse = {
  result?: CancelConnectivitySessionResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CancelConnectivitySessionRequest = {
  vins: string[];
};
export type FuelOrCharge = {
  /** Asset's battery level. */
  batteryInfo?: BatteryInfoJson;
  /** Asset's fuel level. */
  fuelLevel?: FuelLevelJson;
};
export type VehicleListMapsResponse = {
  /** Asset id. */
  id?: string;
  /** Asset's name. */
  name?: string;
  /** Asset's license plate */
  licensePlate?: string;
  /** Asset's vehicle type. */
  vehicleType?: VehicleType;
  /** If asset's diagnostics are critical. */
  diagnosticsCritical?: boolean;
  /** If asset's diagnostics are impaired. */
  diagnosticsImpaired?: boolean;
  /** Asset's fuel or charge level. */
  fuelOrCharge?: FuelOrCharge;
  /** Status of the vehicle based on the gear state. */
  vehicleStatus?: string;
  /** encoded RPO codes. */
  encodedRpoCodes?: string;
  /** Location coordinates of the vehicle. */
  location?: number[];
};
export type PaginatedDataResponseVehicleListMapsResponse = {
  items?: VehicleListMapsResponse[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseVehicleListMapsResponse = {
  result?: PaginatedDataResponseVehicleListMapsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SearchCriteria = {
  /** Asset name */
  name?: string;
};
export type FilterCriteria = {
  assetIds?: string[];
  fuelChargePctLevels?: ('LOW' | 'LOW_TO_MID' | 'MID_TO_HIGH' | 'HIGH')[];
  vehicleStatuses?: (
    | 'PARK'
    | 'OFFLINE'
    | 'MOVING'
    | 'IDLING'
    | 'LOCATION_MASKED'
    | 'UNKNOWN'
  )[];
  diagnosticsStates?: ('OK' | 'WARNING' | 'CRITICAL')[];
};
export type VehicleListMapsRequest = {
  /** Page size for the maps request. */
  size?: number;
  searchCriteria?: SearchCriteria;
  filterCriteria?: FilterCriteria;
};
export type VehicleLocationMapsResponse = {
  /** List of cluster counts. */
  clusters?: number[];
  /** H3 resolution value (0 to 16). */
  h3resolution?: number;
  /** Polyline-encoded string for cluster locations. */
  polylineEncodedClusterLocations?: string;
  /** Polyline-encoded string for vehicle locations. */
  polylineEncodedVehicleLocations?: string;
  /** Map of vehicle VINs and their meta data. Example: gear states, direction, etc. */
  vehicleMetaData?: {
    [key: string]: any[];
  };
};
export type GmResponseCommonVehicleLocationMapsResponse = {
  result?: VehicleLocationMapsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ViewPort = {
  /** Width of the viewport in pixels. */
  width?: number;
  /** Height of the viewport in pixels. */
  height?: number;
};
export type LocationCriteria = {
  /** Viewport dimensions. */
  viewPort?: ViewPort;
  /** Zoom level of the map. */
  zoomLevel?: number;
  /** Bounding box coordinates as a 2D array: [[lat1, lon1], [lat2, lon2]]. */
  boundingBoxCoordinates?: number[][];
  /** Whether to include left navigation panel. */
  includeLeftNavigation?: boolean;
  /** H3 resolution for geospatial indexing. */
  h3Resolution?: number;
};
export type VehicleLocationMapsRequest = {
  /** Page size for the maps request. */
  size?: number;
  searchCriteria?: SearchCriteria;
  filterCriteria?: FilterCriteria;
  /** Criteria for vehicle location on map view. */
  locationCriteria?: LocationCriteria;
};
export type VehicleDataRefreshResponse = {
  acceptedEntries?: string[];
  rejectedEntries?: string[];
};
export type GmResponseCommonVehicleDataRefreshResponse = {
  result?: VehicleDataRefreshResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleDataRefreshRequest = {
  vins?: string[];
};
export type VehicleFieldActionSummaryResponse20241204 = {
  /** Organization ID */
  organizationId?: string;
  /** Total number of vehicles with active field actions. */
  activeFieldActionVehicleCount?: number;
};
export type GmResponseCommonVehicleFieldActionSummaryResponse20241204 = {
  result?: VehicleFieldActionSummaryResponse20241204;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleFieldActionSummaryRequest = {
  fleetId?: string;
};
export type CompletedOperationEntry = {
  vin?: string;
};
export type OperationError = {
  errorCode?: string;
  message?: string;
};
export type FailedOperationEntry = {
  vin?: string;
  error?: OperationError;
};
export type VehicleOwnershipOperationBatchResponse = {
  completedEntries?: CompletedOperationEntry[];
  failedEntries?: FailedOperationEntry[];
};
export type GmResponseCommonVehicleOwnershipOperationBatchResponse = {
  result?: VehicleOwnershipOperationBatchResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleOwnershipOperation = {
  vin: string;
  note?: string;
};
export type VehicleOwnershipOperationBatchRequest = {
  entries: VehicleOwnershipOperation[];
};
export type VehicleFieldActionReportItem = {
  id?: string;
  name?: string;
  licensePlate?: string;
  organization?: OrganizationResponse;
  fleet?: FleetResponse;
  availabilityState?: 'in_service' | 'out_of_service';
  vehicleType?: VehicleType;
  fieldActionSummary?: {
    [key: string]: string[];
  };
};
export type PaginatedDataResponseVehicleFieldActionReportItem = {
  items?: VehicleFieldActionReportItem[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseVehicleFieldActionReportItem =
  {
    result?: PaginatedDataResponseVehicleFieldActionReportItem;
    targetUrl: string;
    __bd: boolean;
    success: boolean;
    unauthorizedRequest: boolean;
    errors: GmResponseError[];
    traceId?: string;
  };
export type VehicleFieldActionReportRequest = {
  /** Page size */
  size?: number;
  searchCriteria?: SearchCriteria;
  filterCriteria?: FilterCriteria;
  /** Continuation token */
  token?: string;
};
export type DiagnosticsValueResponseView = {
  value?: boolean;
  severity?: string;
  severityRank?: number;
  mil?: boolean;
  deviceTimestamp?: string;
  systems?: DiagnosticSystem[];
  name?: string;
  text?: string;
  recommendation?: string[];
};
export type PrognosticsValueResponseView = {
  value?: boolean;
  severity?: string;
  severityRank?: number;
  mil?: boolean;
  deviceTimestamp?: string;
  systems?: PrognosticSystem[];
  name?: string;
  text?: string;
  recommendation?: string[];
};
export type AssetDetailResponseView = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Asset's hardware id such as a VIN. */
  hardwareId?: string;
  /** Asset's license plate. */
  licensePlate?: string;
  /** Fleet that an asset is associated with. */
  fleet?: FleetResponse;
  /** Organization that an asset is associated with. */
  organization?: OrganizationResponse;
  /** Asset state */
  state?: StateResponseJson;
  /** Asset status */
  status?: {
    [key: string]: StatusValueResponse;
  };
  /** Asset configuration */
  configuration?: {
    [key: string]: any;
  };
  /** Asset capabilities */
  capabilities?: {
    [key: string]: string;
  };
  /** Asset timezone. This is inherited from the fleet. */
  timeZone?: string;
  /** Vehicle information such as make, model, year, propulsion */
  vehicleType?: VehicleType;
  /** Asset battery and charging information */
  hvBatteryInfo?: BatteryInfo;
  /** Asset tcps accepted information */
  tcpsAccepted?: boolean;
  /** Vehicle OnStar support status */
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** Vehicle organization primary ownership status */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Asset's connectivity status and enrolled data services */
  connectivity?: TelematicsConnectivity;
  /** Asset creation date */
  creationDate?: string;
  /** Asset last updated time */
  lastUpdated?: string;
  /** Asset readiness */
  ready?: 'ready' | 'not_ready' | 'unknown';
  /** Asset fault count */
  faultCount?: number;
  /** Commands available for the Vehicle */
  availableCommands?: (
    | 'ALERT'
    | 'CANCEL_ALERT'
    | 'START'
    | 'CANCEL_START'
    | 'ENABLE_IGNITION'
    | 'DISABLE_IGNITION'
    | 'LOCK_DOOR'
    | 'UNLOCK_DOOR'
  )[];
  /** Asset diagnostics */
  diagnostics?: {
    [key: string]: DiagnosticsValueResponseView;
  };
  /** Asset prognostics: predicted faults, keyed the same way as diagnostics but kept on their own branch so observed and predicted faults stay distinguishable. */
  prognostics?: {
    [key: string]: PrognosticsValueResponseView;
  };
  /** Unified vehicle connection status derived from OnStar and fleet-adapter providers. */
  connectionStatus?:
    | 'NOT_EQUIPPED'
    | 'CONNECTING'
    | 'CONNECTED'
    | 'DISCONNECTING'
    | 'DISCONNECTED';
  /** For a vehicle asset: true if it is a GM vehicle (exclusively designed and manufactured by General Motors), false otherwise. Null only when the asset is not a vehicle. Consumed by the Vehicle Details page to hide the Recall tile for non-GM vehicles. */
  gmVehicle?: boolean;
};
export type AssetDetailResponseViewPage = {
  items: AssetDetailResponseView[];
  total_items?: number;
  token?: string;
};
export type GmResponseCommonAssetDetailResponseViewPage = {
  result?: AssetDetailResponseViewPage;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EventSubscriptionRequestV2 = {
  type: 'ORG' | 'ASSET_ID';
  id: string;
  organizationId: string;
  cleanFromOthers?: boolean;
};
export type TireStatus = {
  pressureInPSI?: number;
  state?: 'good' | 'impaired' | 'critical' | 'no_data';
  deviceTimestamp?: string;
};
export type TireInfoJson = {
  leftFront?: TireStatus;
  rightFront?: TireStatus;
  leftRear?: TireStatus;
  rightRear?: TireStatus;
  overallStatus?: 'good' | 'impaired' | 'critical' | 'no_data';
};
export type TireReadinessItem = {
  id?: string;
  name?: string;
  licensePlate?: string;
  organization?: OrganizationResponse;
  fleet?: FleetResponse;
  ready?: 'ready' | 'not_ready' | 'unknown';
  lastCommunicated?: LastCommunicated;
  tires?: TireInfoJson;
  vehicleType?: VehicleType;
  availabilityState?: 'in_service' | 'out_of_service';
};
export type TireReadinessItemsResponsePage = {
  items: TireReadinessItem[];
  total_items?: number;
  token?: string;
};
export type GmResponseCommonTireReadinessItemsResponsePage = {
  result?: TireReadinessItemsResponsePage;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AssetDetailResponse = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Asset's hardware id such as a VIN. */
  hardwareId?: string;
  /** Asset's license plate. */
  licensePlate?: string;
  /** Fleet that an asset is associated with. */
  fleet?: FleetResponse;
  /** Organization that an asset is associated with. */
  organization?: OrganizationResponse;
  /** Asset state */
  state?: StateResponseJson;
  /** Asset status */
  status?: {
    [key: string]: StatusValueResponse;
  };
  /** Asset configuration */
  configuration?: {
    [key: string]: any;
  };
  /** Asset capabilities */
  capabilities?: {
    [key: string]: string;
  };
  /** Asset timezone. This is inherited from the fleet. */
  timeZone?: string;
  /** Vehicle information such as make, model, year, propulsion */
  vehicleType?: VehicleType;
  /** Asset battery and charging information */
  hvBatteryInfo?: BatteryInfo;
  /** Asset tcps accepted information */
  tcpsAccepted?: boolean;
  /** Vehicle OnStar support status */
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** Vehicle organization primary ownership status */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Asset's connectivity status and enrolled data services */
  connectivity?: TelematicsConnectivity;
  /** Asset creation date */
  creationDate?: string;
  /** Asset last updated time */
  lastUpdated?: string;
  /** Asset readiness */
  ready?: 'ready' | 'not_ready' | 'unknown';
  /** Asset fault count */
  faultCount?: number;
  /** Commands available for the Vehicle */
  availableCommands?: (
    | 'ALERT'
    | 'CANCEL_ALERT'
    | 'START'
    | 'CANCEL_START'
    | 'ENABLE_IGNITION'
    | 'DISABLE_IGNITION'
    | 'LOCK_DOOR'
    | 'UNLOCK_DOOR'
  )[];
  diagnostics?: {
    [key: string]: DiagnosticsValueResponse;
  };
};
export type AssetDetailResponsePage = {
  items: AssetDetailResponse[];
  total_items?: number;
  token?: string;
};
export type GmResponseCommonAssetDetailResponsePage = {
  result?: AssetDetailResponsePage;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type Asset = Vehicle;
export type AssetWrite = VehicleWrite;
export type GmResponseCommonAsset = {
  result?: Asset | Vehicle;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonAssetWrite = {
  result?: AssetWrite | VehicleWrite;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ProtectedFieldsUpdateRequest = {
  /** Six digit FAN of the asset */
  fan?: string;
};
export type GmResponseCommonVehicleProbe = {
  result?: VehicleProbe;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConfigurationValueJson = {
  properties?: {
    [key: string]: any;
  };
};
export type UpdateConfigurationJson = {
  configuration?: ConfigurationValueJson;
  lastUpdated?: string;
};
export type LegacyUpdateDateAssetEntry = {
  id?: string;
  assetId?: string;
  organizationId?: string;
  updateDate?: string;
};
export type LegacyUpdateDateAssetListResponse = {
  totalItems?: number;
  count?: number;
  items?: LegacyUpdateDateAssetEntry[];
};
export type GmResponseCommonLegacyUpdateDateAssetListResponse = {
  result?: LegacyUpdateDateAssetListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SummaryListEntry = {
  summaryId?: string;
  organizationId?: string;
  createdBy?: string;
  createdDate?: string;
};
export type BatchBoardingSummaryListResponse = {
  totalItems?: number;
  count?: number;
  continuationToken?: string;
  items?: SummaryListEntry[];
};
export type GmResponseCommonBatchBoardingSummaryListResponse = {
  result?: BatchBoardingSummaryListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SessionListEntry = {
  sessionId?: string;
  vin?: string;
  organizationId?: string;
  createdBy?: string;
  createdOn?: string;
};
export type VehicleBoardingSessionListResponse = {
  totalItems?: number;
  count?: number;
  continuationToken?: string;
  items?: SessionListEntry[];
};
export type GmResponseCommonVehicleBoardingSessionListResponse = {
  result?: VehicleBoardingSessionListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleListEntry = {
  vin?: string;
  organizationId?: string;
  model?: string;
  make?: string;
  year?: string;
  gmVehicle?: boolean;
  ownershipStatus?: 'AVAILABLE' | 'CLAIMING' | 'CLAIMED' | 'RELEASING';
  accountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
  createdDate?: string;
};
export type VehicleListResponse20260224 = {
  totalItems?: number;
  count?: number;
  continuationToken?: string;
  items?: VehicleListEntry[];
};
export type GmResponseCommonVehicleListResponse20260224 = {
  result?: VehicleListResponse20260224;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConnectivityProviderVehicleListResponse = {
  totalItems?: number;
  count?: number;
  continuationToken?: string;
  items?: VehicleListEntry[];
};
export type GmResponseCommonConnectivityProviderVehicleListResponse = {
  result?: ConnectivityProviderVehicleListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ClaimedOnstarVehicleListResponse = {
  totalItems?: number;
  count?: number;
  items?: VehicleListEntry[];
};
export type GmResponseCommonClaimedOnstarVehicleListResponse = {
  result?: ClaimedOnstarVehicleListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleListResponse = {
  totalItems?: number;
  count?: number;
  continuationToken?: string;
  items?: VehicleListEntry[];
};
export type GmResponseCommonVehicleListResponse = {
  result?: VehicleListResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleStatusSummary = {
  /** Vehicles awaiting ownership verification (ownership = CLAIMING). */
  verificationPending?: number;
  /** Vehicles that are claimed but have no telematics provider equipped. */
  notEquipped?: number;
  /** Vehicles that are claimed and have an active provider in CONNECTING state. */
  connectionPending?: number;
  /** Vehicles that are claimed and have an active provider in CONNECTED state. */
  connected?: number;
};
export type GmResponseCommonVehicleStatusSummary = {
  result?: VehicleStatusSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PropulsionTypeSummaryResponse = {
  /** Count of ICE vehicles */
  ice?: number;
  /** Count of EV vehicles */
  ev?: number;
  /** Count of HEV vehicles */
  hev?: number;
  /** Count of PHEV vehicles */
  phev?: number;
  /** Count of vehicles with unknown propulsion type */
  unknown?: number;
  /** Total number of vehicles */
  total?: number;
};
export type GmResponseCommonPropulsionTypeSummaryResponse = {
  result?: PropulsionTypeSummaryResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmPageBatchBoardingVehicleSummary = {
  items: BatchBoardingVehicleSummary[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageBatchBoardingVehicleSummary = {
  result?: GmPageBatchBoardingVehicleSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonBatchBoardingVehicleSummary = {
  result?: BatchBoardingVehicleSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BatchSummaryVehicleBoardingSession = {
  id?: string;
  batchId?: string;
  status?:
    | 'PENDING'
    | 'REVIEW'
    | 'COMPLETED'
    | 'FAILED'
    | 'CANCELED'
    | 'REJECTED'
    | 'OTHER';
  reasonCode?: string;
  createdBy?: string;
  createdDate?: string;
  vehicleName?: string;
  vin?: string;
  vehicleModel?: string;
  vehicleMake?: string;
  vehicleYear?: string;
  licensePlate?: string;
  licensePlateExpiration?: string;
  fleetId?: string;
  organizationId?: string;
};
export type GmPageBatchSummaryVehicleBoardingSession = {
  items: BatchSummaryVehicleBoardingSession[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageBatchSummaryVehicleBoardingSession = {
  result?: GmPageBatchSummaryVehicleBoardingSession;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PendingConnectionVehicleItemV20250826 = {
  vin?: string;
  name?: string;
  licensePlate?: string;
  fleetId?: string;
  organizationId?: string;
  vehicleMake?: 'GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET';
  vehicleModel?: string;
  vehicleYear?: string;
  vehicleImageSrc?: string;
  createdDate?: string;
  lastOnboardedDate?: string;
  merchandisingModel?: string;
  stationId?: string;
  peg?: string;
  fan?: string;
  subscriberAccountNumber?: string;
  accountOwnerEmailId?: string;
  pendingConnectionStatus?:
    | 'TERMS_NOT_SIGNED'
    | 'UNIT_STATE_NOT_CONFIGURED'
    | 'UNIT_STATE_DISABLED'
    | 'GRANT_CONSENT_REQUEST_PENDING'
    | 'GRANT_CONSENT_REQUEST_FAILED'
    | 'GRANT_CONSENT_REQUEST_REJECTED'
    | 'ENROLL_TASKS_PENDING'
    | 'ENROLL_TASKS_FAILED'
    | 'NOT_DEFINED';
  /** Advisor connectivity issue category derived from the current ENROLL session.
    RETRIES_STOPPED when the session has failed; PENDING_30_MINUTES_TO_ONE_HOUR,
    PENDING_ONE_HOUR_TO_ONE_DAY, or PENDING_OVER_ONE_DAY for long-pending enrollment
    episodes; otherwise null. */
  connectivityIssueCategory?:
    | 'PENDING_30_MINUTES_TO_ONE_HOUR'
    | 'PENDING_ONE_HOUR_TO_ONE_DAY'
    | 'PENDING_OVER_ONE_DAY'
    | 'RETRIES_STOPPED';
  /** Current ENROLL session recycleCount as persisted; null when absent. */
  retryCount?: number;
  /** Last retry timestamp: session lastRecycleAt, falling back to lastAttempt. */
  lastRetryAt?: string;
  /** Current ENROLL session attemptCount as persisted. */
  checkCount?: number;
  /** Current ENROLL session lastAttempt timestamp. */
  lastCheckedAt?: string;
  vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
  rpoCodes?: string[];
  connectivity?: TelematicsConnectivity;
};
export type GmPagePendingConnectionVehicleItemV20250826 = {
  items: PendingConnectionVehicleItemV20250826[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPagePendingConnectionVehicleItemV20250826 = {
  result?: GmPagePendingConnectionVehicleItemV20250826;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OilLifeStatusSummary = {
  criticalCount?: number;
  lowCount?: number;
  goodCount?: number;
};
export type OilLifeSummary = {
  organizationId?: string;
  fleetId?: string;
  totalIceCount?: number;
  oilLifeStatusSummary?: OilLifeStatusSummary;
};
export type GmResponseCommonOilLifeSummary = {
  result?: OilLifeSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DiagnosticsSummaryItem = {
  criticalCount?: number;
  warningCount?: number;
  okCount?: number;
  totalCount?: number;
};
export type DiagnosticsSummary = {
  organizationId?: string;
  fleetId?: string;
  totalVehicleCount?: number;
  diagnostics?: DiagnosticsSummaryItem;
};
export type GmResponseCommonDiagnosticsSummary = {
  result?: DiagnosticsSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConnectivityStatusItem = {
  /** The primary ownership status of the organization. */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** The OnStar support status. */
  onStarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** The connection status from connectivity.onStar. */
  connectionStatus?:
    | 'CONNECTED'
    | 'CONNECTING'
    | 'DISCONNECTED'
    | 'DISCONNECTING'
    | 'UNKNOWN';
};
export type ConnectivityStatusSummaryV20250826 = {
  /** The ID of the organization. */
  organizationId?: string;
  /** The total count of vehicles. */
  totalVehicleCount?: number;
  /** A list of connectivity status items. */
  items?: ConnectivityStatusItem[];
};
export type GmResponseCommonConnectivityStatusSummaryV20250826 = {
  result?: ConnectivityStatusSummaryV20250826;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ChargeLevelSummary = {
  charging?: number;
  criticalCount?: number;
  lowCount?: number;
  goodCount?: number;
  highCount?: number;
};
export type ChargeStatusSummary = {
  unpluggedCount?: number;
  pluggedCount?: number;
  waitingCount?: number;
  chargingCount?: number;
  completedCount?: number;
  unableCount?: number;
};
export type ChargeSummary = {
  organizationId?: string;
  fleetId?: string;
  totalEVCount?: number;
  chargeLevelSummary?: ChargeLevelSummary;
  chargeStatusSummary?: ChargeStatusSummary;
};
export type GmResponseCommonChargeSummary = {
  result?: ChargeSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleBoardingWorkflowSessionBatchEntry = {
  vin?: string;
  status?:
    | 'PENDING'
    | 'REVIEW'
    | 'COMPLETED'
    | 'FAILED'
    | 'CANCELED'
    | 'REJECTED'
    | 'OTHER';
  context?: string;
};
export type VehicleBoardingWorkflowSessionBatchSummary = {
  id?: string;
  createdBy?: string;
  createdOn?: string;
  organizationId?: string;
  fleetIds?: string[];
  type?: 'ONBOARDING' | 'OFFBOARDING';
  status?: 'PENDING' | 'COMPLETED';
  startedDate?: string;
  completedDate?: string;
  entriesTotalCount?: number;
  entriesPendingCount?: number;
  entriesReviewCount?: number;
  entriesCompletedCount?: number;
  entriesFailedCount?: number;
  entriesRejectedCount?: number;
  entriesCanceledCount?: number;
  entriesOtherCount?: number;
  entries?: VehicleBoardingWorkflowSessionBatchEntry[];
};
export type GmResponseCommonVehicleBoardingWorkflowSessionBatchSummary = {
  result?: VehicleBoardingWorkflowSessionBatchSummary;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type License = {
  level?: string;
  productCode?: string;
};
export type Entitlement = {
  licenses?: License[];
  capabilities?: string[];
  enablements?: string[];
};
export type AssociationValue = {
  id?: string;
};
export type Association = {
  key?: string;
  value?: AssociationValue;
};
export type AssetEntitlement = {
  id?: string;
  assetType?: string;
  name?: string;
  licensePlate?: string;
  vin?: string;
  peg?: string;
  vehicleModel?: string;
  vehicleMake?: string;
  vehicleYear?: string;
  vehicleMerchandisingModel?: string;
  availability?: string;
  provisioning?: string;
  organizationId?: string;
  organizationPrimaryOwnershipStatus?: string;
  fleetId?: string;
  fleetName?: string;
  onStarTcpsAccepted?: boolean;
  entitlement?: Entitlement;
  vehiclePropulsion?: string;
  association?: Association[];
};
export type AzureAiSearchResponseAssetEntitlement = {
  /** List of items returns from search */
  items?: AssetEntitlement[];
  /** Total number of items found */
  totalItems?: number;
};
export type GmResponseCommonAzureAiSearchResponseAssetEntitlement = {
  result?: AzureAiSearchResponseAssetEntitlement;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type Driver = {
  /** Unique identifier for the driver profile */
  driverProfileId?: string;
  /** Full name of the driver */
  name?: string;
  /** Email address of the driver */
  email?: string;
};
export type FleetDto = {
  /** ID of the fleet */
  id?: string;
  /** Name of the fleet */
  name?: string;
};
export type VehicleWithDriverResponse = {
  /** Vehicle VIN */
  vin?: string;
  /** Vehicle name */
  name?: string;
  /** Vehicle make */
  make?: string;
  /** Vehicle model */
  model?: string;
  /** Vehicle year */
  year?: string;
  /** Vehicle image source URL */
  vehicleImageSource?: string;
  /** Driver profile information */
  driver?: Driver;
  /** Fleet details of vehicle */
  fleet?: FleetDto;
};
export type PaginatedDataResponseVehicleWithDriverResponse = {
  items?: VehicleWithDriverResponse[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseVehicleWithDriverResponse = {
  result?: PaginatedDataResponseVehicleWithDriverResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type WorkflowEventData = {
  result?: string;
  context?: string;
};
export type WorkflowEvent = {
  createdOn?: string;
  data?: WorkflowEventData;
  eventType?:
    | 'SESSION_STARTED'
    | 'SESSION_COMPLETED'
    | 'SESSION_FAILED'
    | 'SESSION_TERMINATED'
    | 'SESSION_ARCHIVED'
    | 'ACTIVITY_SCHEDULED'
    | 'ACTIVITY_COMPLETED'
    | 'ACTIVITY_FAILED'
    | 'WAIT_SCHEDULED'
    | 'WAIT_COMPLETED'
    | 'WAIT_FAILED';
  name?: string;
};
export type VehicleProofOfOwnership = {
  status?: 'PENDING' | 'REVIEW' | 'CONFIRMED' | 'REJECTED' | 'CANCELED';
  requestReviewDate?: string;
  requestReviewReason?:
    | 'ONSTAR_ACCOUNT_NO_OWNER_EMAIL'
    | 'ONSTAR_ACCOUNT_NOT_ACTIVE'
    | 'ONSTAR_ACCOUNT_NOT_FOUND'
    | 'ONSTAR_NOT_SUPPORTED'
    | 'ONSTAR_FLEET_ACCOUNT_NO_FAN'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_GEN_NOT_SUPPORTED'
    | 'NO_MATCHING_ONSTAR_ACCOUNT_EMAIL'
    | 'NO_MATCHING_FAN'
    | 'VEHICLE_POWERTRAIN_NOT_SUPPORTED'
    | 'VEHICLE_ACCOUNT_TYPE_NOT_SUPPORTED'
    | 'UNEXPECTED'
    | 'ONSTAR_NOT_AVAILABLE';
  confirmedDate?: string;
  confirmedBy?: string;
  confirmedNote?: string;
  confirmedApproach?: 'AUTO' | 'MANUAL';
  rejectedDate?: string;
  rejectedBy?: string;
  rejectedNote?: string;
  rejectedApproach?: 'AUTO' | 'MANUAL';
  rejectedReason?:
    | 'VEHICLE_REJECTED_ADAPTER_ONSTAR_CONFLICT'
    | 'VEHICLE_REJECTED_INVALID_FLEET_ADAPTER';
};
export type Subscription = {
  state?: 'ACTIVE' | 'INACTIVE';
  organizationId?: string;
  planCode?: 'API_STARTER' | 'API_PRO' | 'API_ELITE';
  serviceCodes?: (
    | 'DTC_NOTIFICATION'
    | 'EV_PHEV_DATA'
    | 'HARD_ACCELERATION'
    | 'HARD_BRAKE'
    | 'INCAB_ALERTS'
    | 'PREDELIVERY'
    | 'TELEMETRY'
  )[];
};
export type VehicleBoardingParameters = {
  fleetAccountNumber?: string;
  onstarAccountNumber?: string;
  onstarTcpsAccepted?: boolean;
  fleetId?: string;
  vehicleName?: string;
  vehicleLicensePlate?: string;
  vehicleLicensePlateExpirationDate?: string;
  connectionPolicy?: 'STANDARD' | 'LIMITED' | 'CUSTOM';
  subscription?: Subscription;
};
export type VehicleBoardingWorkflowSessionDetail = {
  id?: string;
  vin?: string;
  docType?: string;
  batchId?: string;
  createdBy?: string;
  createdOn?: string;
  events?: WorkflowEvent[];
  organizationId?: string;
  ownership?: VehicleProofOfOwnership;
  remoteProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  sessionType?: 'ONBOARDING' | 'OFFBOARDING';
  status?: 'ACTIVE' | 'COMPLETED' | 'FAILED' | 'TERMINATED' | 'ARCHIVED';
  telemetryProvider?: 'Particle' | 'Particle-Sim' | 'OnStar' | 'OnStar-Sim';
  vehicleBoardingParameters?: VehicleBoardingParameters;
  vehicleImageSrc?: string;
  vehicleModel?: string;
  vehicleMake?: string;
  vehicleYear?: string;
  sourceType?: 'API_PLATFORM' | 'FLEET_ADAPTER' | 'MIGRATION' | 'USER';
  sourceId?: string;
  sourceLabel?: string;
};
export type GmPageVehicleBoardingWorkflowSessionDetail = {
  items: VehicleBoardingWorkflowSessionDetail[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageVehicleBoardingWorkflowSessionDetail = {
  result?: GmPageVehicleBoardingWorkflowSessionDetail;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ConnectivityStatusDashboardSummaryItem = {
  /** The ID of the organization. */
  organizationId?: string;
  /** The total count of vehicles. */
  totalVehicleCount?: number;
  /** A list of connectivity status items. */
  items?: ConnectivityStatusItem[];
};
export type GmResponseCommonConnectivityStatusDashboardSummaryItem = {
  result?: ConnectivityStatusDashboardSummaryItem;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ChargeLevelDashboardSummaryResponse = {
  organizationId?: string;
  fleetId?: string;
  totalEVCount?: number;
  chargeLevelSummary?: ChargeLevelSummary;
};
export type GmResponseCommonChargeLevelDashboardSummaryResponse = {
  result?: ChargeLevelDashboardSummaryResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BasicVehicleDetails = {
  /** id also known as vin. */
  id?: string;
  /** the vehicle name. */
  name?: string;
  /** license plate associated with vehicle. */
  licensePlate?: string;
  /** the id of the organization this vehicle is associated with. */
  organizationId?: string;
  /** the id of the fleet this vehicle is associated with. */
  fleetId?: string;
  /** vehicle type. */
  vehicleType?: VehicleType;
};
export type PaginatedDataResponseBasicVehicleDetails = {
  items?: BasicVehicleDetails[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseBasicVehicleDetails = {
  result?: PaginatedDataResponseBasicVehicleDetails;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AzureAiSearchResponseAsset = {
  /** List of items returns from search */
  items?: (Asset | Vehicle)[];
  /** Total number of items found */
  totalItems?: number;
};
export type AzureAiSearchResponseAssetWrite = {
  /** List of items returns from search */
  items?: (AssetWrite | VehicleWrite)[];
  /** Total number of items found */
  totalItems?: number;
};
export type GmResponseCommonAzureAiSearchResponseAsset = {
  result?: AzureAiSearchResponseAsset;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonAzureAiSearchResponseAssetWrite = {
  result?: AzureAiSearchResponseAssetWrite;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type IncompleteOnboardingVehicleListItem = {
  sessionId?: string;
  vin?: string;
  organizationId?: string;
  fleetId?: string;
  reason?:
    | 'UNEXPECTED_FAILURE'
    | 'VEHICLE_REJECTED_ACTIVELY_ONBOARDING'
    | 'VEHICLE_REJECTED_ACTIVELY_OFFBOARDING'
    | 'VEHICLE_REJECTED_CLAIMED_BY_OTHER'
    | 'VEHICLE_REJECTED_CLAIMED_BY_OWNER'
    | 'VEHICLE_REJECTED_DUPLICATE_VIN'
    | 'VEHICLE_REJECTED_NO_INFORMATION_FOUND'
    | 'VEHICLE_REJECTED_INSUFFICIENT_INFORMATION'
    | 'VEHICLE_REJECTED_INVALID_VIN'
    | 'VEHICLE_REJECTED_BATCH_VIN_LIMIT_EXCEEDED'
    | 'VEHICLE_MANUAL_PROOF_OF_OWNERSHIP_REJECTED'
    | 'VEHICLE_REJECTED_NOT_SUPPORTED';
  createdOn?: string;
  createdBy?: string;
  vehicleImageSrc?: string;
  vehicleMake?: string;
  vehicleModel?: string;
  vehicleYear?: string;
};
export type IncompleteOnboardingVehiclesResponse = {
  items?: IncompleteOnboardingVehicleListItem[];
  totalItems?: number;
  token?: string;
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonIncompleteOnboardingVehiclesResponse = {
  result?: IncompleteOnboardingVehiclesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AssetListItem = {
  /** Asset id. */
  id?: string;
  /** Asset name. */
  name?: string;
  /** Asset license plate. */
  licensePlate?: string;
  /** Asset propulsion type. */
  vehicleType?: VehicleType;
  /** Vehicle OnStar tcpsAccepted */
  tcpsAccepted?: boolean;
  /** Vehicle OnStar support status */
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** Fan number. */
  fan?: string;
  /** Organization primary ownership status. */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Organization representation for organization id and name. */
  organization?: OrganizationResponse;
  /** Fleet representation for fleet id and name. */
  fleet?: FleetResponse;
  /** Provisioning state. */
  provisioning?: string;
  /** Telematics connectivity details. */
  connectivity?: TelematicsConnectivity;
  /** Unified vehicle connection status across OnStar and fleet-adapter providers. */
  connectionStatus?:
    | 'NOT_EQUIPPED'
    | 'CONNECTING'
    | 'CONNECTED'
    | 'DISCONNECTING'
    | 'DISCONNECTED';
  /** Vehicle image source URL. */
  vehicleImageSource?: string;
};
export type PaginatedDataResponseAssetListItem = {
  items?: AssetListItem[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseAssetListItem = {
  result?: PaginatedDataResponseAssetListItem;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleIgnitionStatusView = {
  ignitionStatus?: 'ENABLED' | 'DISABLED' | 'UNKNOWN';
};
export type GmResponseCommonVehicleIgnitionStatusView = {
  result?: VehicleIgnitionStatusView;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AssetMinimalStatusObject = {
  value?: any;
  deviceTimestamp?: string;
};
export type AssetStatusView = {
  statuses?: {
    [key: string]: AssetMinimalStatusObject;
  };
};
export type GmResponseCommonAssetStatusView = {
  result?: AssetStatusView;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PendingOnboardingVehicleListItem = {
  sessionId?: string;
  vin?: string;
  organizationId?: string;
  fleetId?: string;
  status?: 'PREPARING' | 'REVIEWING_OWNERSHIP';
  reviewReason?:
    | 'ONSTAR_ACCOUNT_NO_OWNER_EMAIL'
    | 'ONSTAR_ACCOUNT_NOT_ACTIVE'
    | 'ONSTAR_ACCOUNT_NOT_FOUND'
    | 'ONSTAR_NOT_SUPPORTED'
    | 'ONSTAR_FLEET_ACCOUNT_NO_FAN'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_GEN_NOT_SUPPORTED'
    | 'NO_MATCHING_ONSTAR_ACCOUNT_EMAIL'
    | 'NO_MATCHING_FAN'
    | 'VEHICLE_POWERTRAIN_NOT_SUPPORTED'
    | 'VEHICLE_ACCOUNT_TYPE_NOT_SUPPORTED'
    | 'UNEXPECTED'
    | 'ONSTAR_NOT_AVAILABLE';
  createdOn?: string;
  vehicleImageSrc?: string;
  vehicleMake?: 'GMC' | 'BUICK' | 'CADILLAC' | 'CHEVROLET';
  vehicleModel?: string;
  vehicleYear?: string;
  vehicleAccountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
  merchandisingModel?: string;
  peg?: string;
  rpoCodes?: string[];
  fan?: string;
  onStar?: OnStar;
};
export type PendingOnboardingVehiclesResponse = {
  items?: PendingOnboardingVehicleListItem[];
  totalItems?: number;
  token?: string;
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonPendingOnboardingVehiclesResponse = {
  result?: PendingOnboardingVehiclesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleFieldActionDetails = {
  title?: string;
  releaseDate?: string;
  type?: 'ZPSR' | 'ZPER' | 'ZNCR' | 'ZCSP';
};
export type VehicleFieldActionDetailsResponse = {
  id?: string;
  fieldActions?: VehicleFieldActionDetails[];
};
export type GmResponseCommonVehicleFieldActionDetailsResponse = {
  result?: VehicleFieldActionDetailsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleBoardingProfileDetail = {
  id?: string;
  vin?: string;
  docType?: string;
  status?: 'INACTIVE' | 'OFFBOARDING' | 'ONBOARDING';
  organizationId?: string;
  createdOn?: string;
  updatedOn?: string;
  lastCompletedBoardingSessionId?: string;
  lastAbortedBoardingSessionId?: string;
  currentBoardingSessionId?: string;
};
export type GmResponseCommonVehicleBoardingProfileDetail = {
  result?: VehicleBoardingProfileDetail;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonVehicleBoardingWorkflowSessionDetail = {
  result?: VehicleBoardingWorkflowSessionDetail;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonString = {
  result?: string;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AssetByIdDetailResponse = {
  /** Asset id */
  id?: string;
  /** Asset name */
  name?: string;
  /** Asset's hardware id such as a VIN. */
  hardwareId?: string;
  /** Asset's license plate. */
  licensePlate?: string;
  /** Fleet that an asset is associated with. */
  fleet?: FleetResponse;
  /** Organization that an asset is associated with. */
  organization?: OrganizationResponse;
  /** Asset state */
  state?: StateResponseJson;
  /** Asset status */
  status?: {
    [key: string]: StatusValueResponse;
  };
  /** Asset configuration */
  configuration?: {
    [key: string]: any;
  };
  /** Asset capabilities */
  capabilities?: {
    [key: string]: string;
  };
  /** Asset timezone. This is inherited from the fleet. */
  timeZone?: string;
  /** Vehicle information such as make, model, year, propulsion */
  vehicleType?: VehicleType;
  /** Asset battery and charging information */
  hvBatteryInfo?: BatteryInfo;
  /** Asset tcps accepted information */
  tcpsAccepted?: boolean;
  /** Vehicle OnStar support status */
  onstarSupportStatus?:
    | 'SUPPORTED'
    | 'ONSTAR_NOT_EQUIPPED'
    | 'ONSTAR_DELETED'
    | 'ONSTAR_UNIT_GENERATION_ID_NOT_SUPPORTED'
    | 'GOVERNMENT_BUILD_ONSTAR_NOT_SUPPORTED';
  /** Vehicle organization primary ownership status */
  organizationPrimaryOwnershipStatus?:
    | 'AVAILABLE'
    | 'CLAIMING'
    | 'CLAIMED'
    | 'RELEASING';
  /** Asset's connectivity status and enrolled data services */
  connectivity?: TelematicsConnectivity;
  /** Asset creation date */
  creationDate?: string;
  /** Asset last updated time */
  lastUpdated?: string;
  /** Asset readiness */
  ready?: 'ready' | 'not_ready' | 'unknown';
  /** Asset fault count */
  faultCount?: number;
  /** Commands available for the Vehicle */
  availableCommands?: (
    | 'ALERT'
    | 'CANCEL_ALERT'
    | 'START'
    | 'CANCEL_START'
    | 'ENABLE_IGNITION'
    | 'DISABLE_IGNITION'
    | 'LOCK_DOOR'
    | 'UNLOCK_DOOR'
  )[];
  diagnostics?: {
    [key: string]: DiagnosticsValueResponse;
  };
  offlineAccessToken?: string;
  fan?: string;
  /** OnStar subscription and vehicle architecture data */
  onStar?: OnStar;
  /** Account type of the vehicle (e.g. fleet, retail). Null when the asset is not a vehicle or the account type is not set. */
  accountType?: 'FL' | 'RN' | 'PN' | 'BN' | 'CV' | 'DD' | 'DH';
};
export type GmResponseCommonAssetByIdDetailResponse = {
  result?: AssetByIdDetailResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SafetyComplianceInfo = {
  value?: boolean;
  lastUpdated?: string;
  complianceStatus?: {
    [key: string]: boolean;
  };
};
export type ChargingComplianceStatus = {
  chargingScheduleCompliant?: boolean;
  homeLocationCompliant?: boolean;
};
export type ChargingComplianceInfo = {
  value?: boolean;
  complianceStatus?: ChargingComplianceStatus;
};
export type ComplianceItem = {
  id?: string;
  name?: string;
  organization?: OrganizationResponse;
  fleet?: FleetResponse;
  safetyCompliance?: SafetyComplianceInfo;
  chargingCompliance?: ChargingComplianceInfo;
};
export type ComplianceReportPage = {
  items: ComplianceItem[];
  total_items?: number;
  token?: string;
};
export type GmResponseCommonComplianceReportPage = {
  result?: ComplianceReportPage;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BatterySummaryItem = {
  critical?: number;
  impaired?: number;
  info0?: number;
  info1?: number;
  no_data?: number;
};
export type ChargeSummaryItem = {
  charging?: number;
  no_data?: number;
};
export type DiagnosticSummaryItem = {
  tire_low?: number;
  tire_flat?: number;
  fluid_low_brake?: number;
  fluid_low_washer?: number;
  mil_critical?: number;
  mil_impaired?: number;
};
export type ConnectivitySummaryItem = {
  online?: number;
  offline?: number;
  no_data?: number;
};
export type AvailabilitySummaryItem = {
  in_service?: number;
  out_of_service?: number;
};
export type DashboardSummaryItem = {
  type?: string;
  total?: number;
  ready?: number;
  battery?: BatterySummaryItem;
  charge?: ChargeSummaryItem;
  diagnostics?: DiagnosticSummaryItem;
  connectivity?: ConnectivitySummaryItem;
  availability?: AvailabilitySummaryItem;
  not_ready?: number;
};
export type BatterySettings = {
  thresholds?: {
    [key: string]: number;
  };
};
export type DashboardSettings = {
  battery?: BatterySettings;
};
export type DashboardSummaryWrapper = {
  summaries?: DashboardSummaryItem[];
  settings?: DashboardSettings;
};
export type GmResponseCommonDashboardSummaryWrapper = {
  result?: DashboardSummaryWrapper;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AddressJson = {
  /** Address line 1 */
  line1?: string;
  /** Address line 2 */
  line2?: string;
  /** Address city */
  city?: string;
  /** Address state or province */
  state?: string;
  /** Address postal code */
  postalCode?: string;
  /** Address country */
  country?: string;
};
export type LocationResponseJson = {
  lon?: number;
  lat?: number;
  address?: AddressJson;
};
export type OperationalStatus = {
  primary?: 'OFFLINE' | 'STOPPED' | 'MOVING' | 'UNKNOWN';
  speed?: number;
  direction?: number;
  lastUpdated?: string;
};
export type ViewMapListItem = {
  id?: string;
  name?: string;
  battery?: BatteryInfo;
  location?: LocationResponseJson;
  operational?: OperationalStatus;
  connectivity?: 'online' | 'offline';
  brakeFluid?: 'good' | 'critical' | 'no_data';
  washerFluidState?: 'good' | 'impaired' | 'no_data';
  tires?: 'good' | 'impaired' | 'critical' | 'no_data';
  ready?: boolean;
  faultCount?: number;
  milState?: string;
  availability?: 'in_service' | 'out_of_service';
  cubbyTempState?: 'good' | 'impaired' | 'critical';
  lastCommunicated?: string;
};
export type PaginatedDataResponseViewMapListItem = {
  items?: ViewMapListItem[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseViewMapListItem = {
  result?: PaginatedDataResponseViewMapListItem;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonAssetDetailResponseView = {
  result?: AssetDetailResponseView;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export const {
  useUpdateAssetMutation,
  useDeleteAssetMutation,
  useListPartnerVehiclesMutation,
  useRepairUpdateDatesMutation,
  useResetFleetTelemetryMutation,
  useUpdateSummaryMutation,
  useUpdateSessionMutation,
  useUpdateVehicleMutation,
  useUpdateVehicle1Mutation,
  useUpdateVehicle2Mutation,
  useUpdateVehicleBatchMutation,
  useUpdateVehicle3Mutation,
  useExecuteRemoteCommandsMfaMutation,
  useResetVehiclesMutation,
  useCleanupFakeVinsMutation,
  useOffboardAllOrganizationVehiclesMutation,
  useBulkGetOviVehiclesMutation,
  useValidateVehiclesMutation,
  useSeedVehicleMutation,
  useOffboardVehiclesMutation,
  useListVerifiedVehiclesQuery,
  useListMigratedVehiclesQuery,
  useSyncVehiclesMutation,
  useSubscriptionOnboardVehiclesMutation,
  useSubscriptionOffboardVehiclesMutation,
  useExportVehicleListOverviewCsvFromSearchMutation,
  useBulkGetVehicleBasicInfoMutation,
  useGetVehicleOverviewListQuery,
  useExportVehicleDiagnosticsListMutation,
  useGetAssetBatteryReadinessV20260113Mutation,
  useExportAssetBatteryReadinessCsvV20260113Mutation,
  useGetVehiclesWithDriversAndPeripheralsUsingBdQueryMutation,
  useProbeVehicleMutation,
  useGetVehiclesWithDriversAndPeripheralsMutation,
  useChangeFleetForVehiclesMutation,
  useCancelBatchMutation,
  useExportVehicleListOverviewCsvMutation,
  useGetVehicleOverviewList1Mutation,
  useGetVehicleDiagnosticsListQuery,
  useExportPendingConnectionVehiclesMutation,
  useExportPendingOnboardingVehiclesMutation,
  useRefreshBatchSummaryMutation,
  useGetAssetReadinessV20250909Mutation,
  useExportAssetReadinessCsvV20250909Mutation,
  useExportAssetFluidReadinessCsvV20250909Mutation,
  useMigratePreviouslyConnectedVehicleToConnectivityMutation,
  useGetBatchIgnitionStatusMutation,
  useArchiveVehicleBoardingSessionMutation,
  useSendConnectivityRestartRequestMutation,
  useRetryOnboardingVehiclesMutation,
  useTriggerSearchIndexRefreshMutation,
  useCancelSessionsMutation,
  useGetMapAssetDetailsQuery,
  useGetMapLocationSummaryQuery,
  useTerminateVehicleBoardingSessionMutation,
  useBatchOffBoardVehiclesMutation,
  useRefreshVehicleDataMutation,
  useTriggerAddCapabilitiesEventMutation,
  useBatchOnboardVehiclesV2Mutation,
  useTriggerEventMutation,
  useGetActiveFieldActionVehicleSummaryMutation,
  useGetAssetReadinessV20241203Mutation,
  useRejectVehicleProofOfOwnershipMutation,
  useConfirmVehicleProofOfOwnershipMutation,
  useGetFieldActionSummaryReportMutation,
  useUpsertAssetMutation,
  useGetAssetsByPageMutation,
  useDoSubscribeV2Mutation,
  useGetAssetWithTireReadinessMutation,
  useSearchAssetsMutation,
  useUpdateProtectedFieldsForAssetMutation,
  useResetOwnershipMutation,
  usePatchVehicleProbeMutation,
  useResetOwnership1Mutation,
  usePatchVehicleInfoFieldsMutation,
  useUpdateConfigurationMutation,
  useListAssetsWithArrayUpdateDateQuery,
  useListSummariesQuery,
  useListSessionsQuery,
  useListVehiclesQuery,
  useListVehicles1Query,
  useListVehicles2Query,
  useListVehicles3Query,
  useGetVehicleImageUrlQuery,
  useGetVehicleStatusDashboardSummaryMetricsV20260602Query,
  useGetVehicleImageUrlWithParamsQuery,
  useGetPropulsionSummaryQuery,
  useListBatchSummariesQuery,
  useGetBatchSummaryByIdQuery,
  useGetBatchSessionsByIdQuery,
  useGet20250923BoardingBatchesByBatchIdExtendedQuery,
  useExportBatchVehiclesToCsvQuery,
  useListPendingConnectionVehiclesQuery,
  useGetOilLifeSummaryMetricsV20250826Query,
  useGetDiagnosticsSummaryMetricsV20250826Query,
  useGetConnectivityStatusDashboardSummaryMetricsV20250826Query,
  useGetChargeSummaryMetricsV20250826Query,
  useGetSummaryOfBoardingSessionsQuery,
  useSearchAssetQuery,
  useGetVehiclesWithDriversQuery,
  useListVehicleBoardingSessionsQuery,
  useGetOilLifeSummaryMetricsQuery,
  useGetDiagnosticsSummaryMetricsQuery,
  useGetConnectivityStatusSummaryMetricsQuery,
  useGetChargeLevelSummaryMetricsQuery,
  useGetVehiclesBasicDetailsQuery,
  useSearchAsset1Query,
  useListIncompleteOnboardingVehiclesQuery,
  useGetAssetsListQuery,
  useGetVehicleIgnitionStatusQuery,
  useGetAssetStatusWithFilteringQuery,
  useListPendingOnboardingVehiclesQuery,
  useExecuteRemoteCommandsQuery,
  useGetChargeLevelDashboardSummaryQuery,
  useGetFieldActionsForVinQuery,
  useGet20240717ByAssetIdInternalQuery,
  useGetVehicleBoardingProfileQuery,
  useGetCurrentVehicleBoardingSessionQuery,
  useGetVehicleBoardingSessionBySessionIdQuery,
  useGetOrganizationIdByAssetIdQuery,
  useGetAssetByIdWithFanQuery,
  useGetComplianceReportV2Query,
  useGetDashboardMetricsQuery,
  useGetMapListItemsQuery,
  useGetAssetWithi8NDetailsQuery,
  useDeleteVehiclesMutation,
} = injectedRtkApi;
